[
  {
    "id": "ab-testing",
    "label": "A/B Testing",
    "labels": [
      "A/B Testing",
      "Split Testing",
      "Online Controlled Experiment"
    ],
    "size": 20,
    "color": "#92ef80",
    "qualityType": "approach",
    "page": "/approaches/ab-testing"
  },
  {
    "id": "access-control",
    "label": "Access Control",
    "labels": [
      "Access Control"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/access-control",
    "standards": [
      "pcidss",
      "iec62443",
      "gdpr",
      "sox",
      "ieee2857",
      "owaspasvs",
      "soc2"
    ],
    "excerpt": "... who is authorized to access to the product (both functionality and data), under what circumstances that access is granted, and to which parts of the product access is allowed."
  },
  {
    "id": "access-control-is-enforced",
    "label": "Access control is enforced",
    "labels": [
      "Access control is enforced"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/access-control-is-enforced"
  },
  {
    "id": "access-control-via-sso",
    "label": "Access Control via SSO",
    "labels": [
      "Access Control via SSO"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/access-control-via-sso"
  },
  {
    "id": "access-find-function-quickly",
    "label": "Access find function in three seconds",
    "labels": [
      "Access find function in three seconds"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/access-find-function-quickly"
  },
  {
    "id": "accessibility",
    "label": "Accessibility",
    "labels": [
      "Accessibility"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/accessibility",
    "standards": [
      "iso26514",
      "iso25024",
      "ieee2857",
      "wcag22",
      "en301549",
      "iso25019"
    ],
    "excerpt": "Capability of a product or system to be usable by people with the widest range of characteristics and capabilities to achieve a specified goal in a specified context of use."
  },
  {
    "id": "accessible-user-interface",
    "label": "Accessible User Interface",
    "labels": [
      "Accessible User Interface"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/accessible-user-interface"
  },
  {
    "id": "accountability",
    "label": "Accountability",
    "labels": [
      "Accountability"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/accountability",
    "standards": [
      "iso38500",
      "iso25010",
      "iso27001",
      "pcidss",
      "iso42001",
      "aiuc1",
      "cra",
      "gdpr",
      "iso42030",
      "sox",
      "ieee2857",
      "iso24028",
      "etsien304223",
      "soc2",
      "nistairmf",
      "ieee7000"
    ],
    "excerpt": "Capability of a product to enable actions of an entity to be traced uniquely to the entity"
  },
  {
    "id": "accuracy",
    "label": "Accuracy",
    "labels": [
      "Accuracy",
      "Exactness"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/accuracy",
    "standards": [
      "iso25024",
      "sox",
      "iso24028",
      "iso8000"
    ],
    "excerpt": "The degree of conformity of a measured or calculated value to the true value, typically based on a global reference system."
  },
  {
    "id": "accurate-estimate-of-insurance-rate",
    "label": "Accurate estimate of insurance contract rate",
    "labels": [
      "Accurate estimate of insurance contract rate"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/accurate-estimate-of-insurance-rate"
  },
  {
    "id": "adaptability",
    "label": "Adaptability",
    "labels": [
      "Adaptability"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/adaptability",
    "standards": [
      "iso25010"
    ],
    "excerpt": "Capability of a product to be effectively and efficiently adapted for or transferred to different hardware, software or other operational or usage environments"
  },
  {
    "id": "add-new-product",
    "label": "Add new product under 60 minutes",
    "labels": [
      "Add new product under 60 minutes"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/add-new-product"
  },
  {
    "id": "adding-entity-type-within-5-days",
    "label": "Adding a new entity type within 5 days and ≤ 3 modules",
    "labels": [
      "Adding a new entity type within 5 days and ≤ 3 modules"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/adding-entity-type-within-5-days"
  },
  {
    "id": "affordability",
    "label": "Affordability",
    "labels": [
      "Affordability",
      "Budget Constraint",
      "Value For Money"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/affordability",
    "excerpt": "\"the state of being cheap enough for people to be able to buy.\""
  },
  {
    "id": "affordable-crm",
    "label": "Affordable CRM (customer relationship management)",
    "labels": [
      "Affordable CRM (customer relationship management)"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/affordable-crm"
  },
  {
    "id": "agility",
    "label": "Agility",
    "labels": [
      "Agility"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/agility",
    "excerpt": "A system can rapidly be changed (as opposed to flexibility, which means that a system can easily be changed.)"
  },
  {
    "id": "aiuc1",
    "label": "AIUC-1 – AI Agent Standard",
    "size": 45,
    "color": "#ffc95c",
    "qualityType": "standard",
    "page": "/standards/aiuc-1"
  },
  {
    "id": "analysability",
    "label": "Analysability",
    "labels": [
      "Analysability",
      "Inspectability"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/analysability",
    "standards": [
      "iso25010",
      "misra-c",
      "iso42030"
    ],
    "excerpt": "Capability of a product to be effectively and efficiently assessed regarding the impact of an intended change to one or more of its parts, to diagnose it for deficiencies or causes of failures, or to identify parts to be modified."
  },
  {
    "id": "anticipated-workplace-environment",
    "label": "Anticipated Workplace Environment",
    "labels": [
      "Anticipated Workplace Environment"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/anticipated-workplace-environment",
    "excerpt": "This describes the workplace in which the users are to work and use the product. It should describe any features of the workplace that could have an effect on the design of the product, and the social and cultural aspects of the workplace."
  },
  {
    "id": "deploy-to-production-within-15-minutes",
    "label": "Any passing build deploys to production within 15 minutes",
    "labels": [
      "Any passing build deploys to production within 15 minutes"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/deploy-to-production-within-15-minutes"
  },
  {
    "id": "api-gateway",
    "label": "API Gateway",
    "labels": [
      "API Gateway"
    ],
    "size": 20,
    "color": "#92ef80",
    "qualityType": "approach",
    "page": "/approaches/api-gateway"
  },
  {
    "id": "appearance",
    "label": "Appearance",
    "labels": [
      "Appearance"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/appearance",
    "excerpt": "Your client may have made particular demands for the product, such as corporate branding, colours to be used, and so on."
  },
  {
    "id": "appearance-requirements",
    "label": "Appearance of mobile UI",
    "labels": [
      "Appearance of mobile UI"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/appearance-requirements"
  },
  {
    "id": "appropriateness-recognizability",
    "label": "Appropriateness recognizability",
    "labels": [
      "Appropriateness recognizability"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/appropriateness-recognizability",
    "standards": [
      "iso25010"
    ],
    "excerpt": "Capability of a product to be recognized by users as appropriate for their needs."
  },
  {
    "id": "assess-impact-of-proposed-change",
    "label": "Assess impact of proposed change",
    "labels": [
      "Assess impact of proposed change"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/assess-impact-of-proposed-change"
  },
  {
    "id": "asynchronous-messaging",
    "label": "Asynchronous Messaging",
    "labels": [
      "Asynchronous Messaging"
    ],
    "size": 20,
    "color": "#92ef80",
    "qualityType": "approach",
    "page": "/approaches/asynchronous-messaging"
  },
  {
    "id": "atomicity",
    "label": "Atomicity",
    "labels": [
      "Atomicity"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/atomicity",
    "excerpt": "Atomicity ensures that a transaction is an all-or-nothing unit of work: either all operations are applied, or none are. This prevents partially applied changes and hazardous intermediate states."
  },
  {
    "id": "attractive-quality-knowledge-base",
    "label": "Attractive Appearance of Website",
    "labels": [
      "Attractive Appearance of Website"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/attractive-quality-knowledge-base"
  },
  {
    "id": "attractiveness",
    "label": "Attractiveness",
    "labels": [
      "Attractiveness"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/attractiveness",
    "excerpt": "Attractiveness summarizes properties that make software appealing to users and stakeholders. Attractive software typically exhibits…"
  },
  {
    "id": "auditability",
    "label": "Auditability",
    "labels": [
      "Auditability"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/auditability",
    "standards": [
      "iso38500",
      "iso26262",
      "misra-c",
      "hl7",
      "iso15408",
      "cra",
      "iec62443",
      "do178c",
      "iso42010",
      "gdpr",
      "iso42030",
      "sox",
      "ieee2857",
      "etsien304223",
      "owaspasvs",
      "soc2",
      "ieee7000",
      "dicom",
      "ihe",
      "c3a"
    ],
    "excerpt": "... what the product has to do (usually retain records) to permit the required audit checks."
  },
  {
    "id": "authenticity",
    "label": "Authenticity",
    "labels": [
      "Authenticity"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/authenticity",
    "standards": [
      "iso25010",
      "iso27001",
      "pcidss",
      "iso15408",
      "cra",
      "gdpr",
      "sox",
      "ieee2857",
      "owaspasvs"
    ],
    "excerpt": "Capability of a product to prove that the identity of a subject or resource is the one claimed."
  },
  {
    "id": "authenticity-of-digital-document",
    "label": "Authenticity of a digital document",
    "labels": [
      "Authenticity of a digital document"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/authenticity-of-digital-document"
  },
  {
    "id": "personal-data-lifecycle-protection",
    "label": "Automated Personal Data Lifecycle Protection",
    "labels": [
      "Automated Personal Data Lifecycle Protection"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/personal-data-lifecycle-protection"
  },
  {
    "id": "autonomy",
    "label": "Autonomy",
    "labels": [
      "Autonomy",
      "Autonomicity",
      "Self Configuring",
      "Self Healing",
      "Self Optimizing",
      "Self Protecting"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/autonomy",
    "standards": [
      "c3a"
    ],
    "excerpt": "An autonomous decentralized system is a decentralized system composed of modules or components that are designed to operate independently but are capable of interacting with each other to meet the overall goal of the system."
  },
  {
    "id": "availability",
    "label": "Availability",
    "labels": [
      "Availability",
      "High Availability",
      "Uptime"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/availability",
    "standards": [
      "iso25010",
      "iso27001",
      "iso26262",
      "pcidss",
      "hl7",
      "iso15408",
      "cra",
      "iec62443",
      "iso25024",
      "iso12207",
      "sox",
      "iso24028",
      "etsien304223",
      "soc2",
      "dicom",
      "ihe"
    ],
    "excerpt": "Capability of a product to be accessible and operational when required for use."
  },
  {
    "id": "available-7-24-99",
    "label": "Available 7x24 with 99% uptime",
    "labels": [
      "Available 7x24 with 99% uptime"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/available-7-24-99"
  },
  {
    "id": "avoid-common-vulnerabilities",
    "label": "Avoid common vulnerabilities",
    "labels": [
      "Avoid common vulnerabilities"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/avoid-common-vulnerabilities"
  },
  {
    "id": "b-method",
    "label": "B-Method",
    "labels": [
      "B-Method"
    ],
    "size": 20,
    "color": "#92ef80",
    "qualityType": "approach",
    "page": "/approaches/b-method"
  },
  {
    "id": "backends-for-frontends",
    "label": "Backends for Frontends",
    "labels": [
      "Backends for Frontends",
      "BFF"
    ],
    "size": 20,
    "color": "#92ef80",
    "qualityType": "approach",
    "page": "/approaches/backends-for-frontends"
  },
  {
    "id": "backpressure-propagation",
    "label": "Backpressure Propagation",
    "labels": [
      "Backpressure Propagation",
      "Flow Control"
    ],
    "size": 20,
    "color": "#92ef80",
    "qualityType": "approach",
    "page": "/approaches/backpressure-propagation"
  },
  {
    "id": "backup-patient-monitoring-sensor",
    "label": "Backup patient monitoring sensor takes over",
    "labels": [
      "Backup patient monitoring sensor takes over"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/backup-patient-monitoring-sensor"
  },
  {
    "id": "backward-compatibility",
    "label": "Backward compatibility",
    "labels": [
      "Backward compatibility",
      "Legacy Support"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/backward-compatibility",
    "excerpt": "Backward compatibility is a property of an operating system, product, or technology that allows for interoperability with an older legacy system, or with input designed for such a system, especially in telecommunications and computing."
  },
  {
    "id": "bias-mitigation",
    "label": "Bias Mitigation",
    "labels": [
      "Bias Mitigation"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/bias-mitigation",
    "standards": [
      "isoiec22989",
      "ieee7000"
    ],
    "excerpt": "Bias mitigation refers to the systematic identification and reduction of unfair prejudice in algorithmic systems, particularly those using artificial intelligence and machine learning. It involves techniques and practices designed to preven…"
  },
  {
    "id": "blue-green-deployment",
    "label": "Blue-Green Deployment",
    "labels": [
      "Blue-Green Deployment"
    ],
    "size": 20,
    "color": "#92ef80",
    "qualityType": "approach",
    "page": "/approaches/blue-green-deployment"
  },
  {
    "id": "budget-constraint-library-update",
    "label": "Budget constrained library update",
    "labels": [
      "Budget constrained library update"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/budget-constraint-library-update"
  },
  {
    "id": "bulkheads",
    "label": "Bulkheads",
    "labels": [
      "Bulkheads"
    ],
    "size": 20,
    "color": "#92ef80",
    "qualityType": "approach",
    "page": "/approaches/bulkheads"
  },
  {
    "id": "c3a",
    "label": "C3A — Criteria enabling Cloud Computing Autonomy",
    "size": 45,
    "color": "#ffc95c",
    "qualityType": "standard",
    "page": "/standards/c3a"
  },
  {
    "id": "caching",
    "label": "Caching",
    "labels": [
      "Caching"
    ],
    "size": 20,
    "color": "#92ef80",
    "qualityType": "approach",
    "page": "/approaches/caching"
  },
  {
    "id": "calibration",
    "label": "Calibration",
    "labels": [
      "Calibration"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/calibration",
    "standards": [
      "nistairmf",
      "iso24028"
    ],
    "excerpt": "A radiology assistant reports a 92% probability of pneumonia on a chest X-ray. If, across 1,000 such 92%-confident predictions, the finding is actually present in only about 730 cases, the model is overconfident by roughly 20 points. A tria…"
  },
  {
    "id": "canary-deployment",
    "label": "Canary Deployment",
    "labels": [
      "Canary Deployment",
      "Scale Rollouts"
    ],
    "size": 20,
    "color": "#92ef80",
    "qualityType": "approach",
    "page": "/approaches/canary-deployment"
  },
  {
    "id": "capacity",
    "label": "Capacity",
    "labels": [
      "Capacity"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/capacity",
    "standards": [
      "iso25010",
      "iso14756"
    ],
    "excerpt": "System meets requirements for the maximum limits of system parameter."
  },
  {
    "id": "capacity-to-process-sensor-inputs",
    "label": "Capacity to process 1000 sensor inputs per minute",
    "labels": [
      "Capacity to process 1000 sensor inputs per minute"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/capacity-to-process-sensor-inputs"
  },
  {
    "id": "capture-unresolved-business-semantics-without-structural-commitment",
    "label": "Capture unresolved business semantics without structural commitment",
    "labels": [
      "Capture unresolved business semantics without structural commitment"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/capture-unresolved-business-semantics-without-structural-commitment"
  },
  {
    "id": "carbon-emission-efficiency",
    "label": "Carbon Emission Efficiency",
    "labels": [
      "Carbon Emission Efficiency",
      "Carbon Efficiency"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/carbon-emission-efficiency",
    "excerpt": "... refers to the economic benefits generated by production activities that produce carbon emissions at the same time. The less carbon emissions generated per unit of economic output, the more carbon emission efficient it is."
  },
  {
    "id": "certifiability",
    "label": "Certifiability",
    "labels": [
      "Certifiability"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/certifiability",
    "standards": [
      "iso26262",
      "do178c",
      "iec62304",
      "iec61508",
      "ihe"
    ],
    "excerpt": "The degree to which a system can be certified to meet specific regulatory, safety, or quality standards through demonstration of compliance evidence."
  },
  {
    "id": "change-failure-rate",
    "label": "Change failure rate",
    "labels": [
      "Change failure rate"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/change-failure-rate",
    "excerpt": "Change failure rate: the percentage of code changes that require hot fixes or other remediation after production. This does not measure failures caught by testing and fixed before code is deployed."
  },
  {
    "id": "changeability",
    "label": "Changeability",
    "labels": [
      "Changeability",
      "Mutability"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/changeability",
    "excerpt": "One common theme popping up in projects is that change is the only constant. Code changes, architecture changes, technology changes, requirements change and people change. But often, change comes at a high cost. Things were just not prepare…"
  },
  {
    "id": "circuit-breaker",
    "label": "Circuit Breaker",
    "labels": [
      "Circuit Breaker"
    ],
    "size": 20,
    "color": "#92ef80",
    "qualityType": "approach",
    "page": "/approaches/circuit-breaker"
  },
  {
    "id": "clarity",
    "label": "Clarity",
    "labels": [
      "Clarity"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/clarity",
    "standards": [
      "iso26514",
      "iso42010",
      "iso42030",
      "iso12207"
    ],
    "excerpt": "The quality of being coherent and intelligible."
  },
  {
    "id": "clarity-in-technical-documentation",
    "label": "Clarity in technical documentation",
    "labels": [
      "Clarity in technical documentation"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/clarity-in-technical-documentation"
  },
  {
    "id": "co-existence",
    "label": "Co-existence",
    "labels": [
      "Co-existence"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/co-existence",
    "standards": [
      "iso25010"
    ],
    "excerpt": "Capability of a product to perform its required functions efficiently while sharing a common environment and resources with other products, without detrimental impact on any other product."
  },
  {
    "id": "code-complexity",
    "label": "Code Complexity",
    "labels": [
      "Code Complexity"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/code-complexity",
    "excerpt": "A quantitative measure whether there is not more than an adequate number of linearly independent paths through a program’s source code. It was developed by Thomas J. McCabe, Sr. in 1976."
  },
  {
    "id": "code-readability",
    "label": "Code Readability",
    "labels": [
      "Code Readability"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/code-readability",
    "excerpt": "Readability, to me, means that the code is easy to follow, logically."
  },
  {
    "id": "coherence",
    "label": "Coherence",
    "labels": [
      "Coherence"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/coherence",
    "standards": [
      "iso42010",
      "iso42030",
      "iso12207"
    ],
    "excerpt": "I will contend that conceptual integrity is the most important consideration in system design. It is better to have a system omit certain anomalous features and improvements, but to reflect one set of design ideas, than to have one that con…"
  },
  {
    "id": "cohesion",
    "label": "Cohesion",
    "labels": [
      "Cohesion"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/cohesion",
    "excerpt": "In computer programming, cohesion refers to the degree to which the elements inside a module belong together."
  },
  {
    "id": "communicability",
    "label": "Communicability",
    "labels": [
      "Communicability"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/communicability",
    "standards": [
      "iso42010",
      "iso42030"
    ],
    "excerpt": "Communicability in software systems refers to the clarity and effectiveness with which the system conveys its functions and usability to the user. This includes the design of the user interface, the presentation of information, and the syst…"
  },
  {
    "id": "compatibility",
    "label": "Compatibility",
    "labels": [
      "Compatibility"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/compatibility",
    "standards": [
      "iso25010",
      "hl7",
      "iso42030",
      "iso12207",
      "dicom",
      "ihe"
    ],
    "excerpt": "Capability of a product to exchange information with other products, and/or to perform its required functions while sharing the same common environments and resources."
  },
  {
    "id": "compatible-with-5-battery-providers",
    "label": "Compatible with 5 different battery providers",
    "labels": [
      "Compatible with 5 different battery providers"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/compatible-with-5-battery-providers"
  },
  {
    "id": "completeness",
    "label": "Completeness",
    "labels": [
      "Completeness"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/completeness",
    "standards": [
      "iso25024",
      "iso8000",
      "iso25012"
    ],
    "excerpt": "The degree to which all required data is present and no essential information is missing."
  },
  {
    "id": "compliance",
    "label": "Compliance",
    "labels": [
      "Compliance",
      "Standard Compliance"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/compliance",
    "standards": [
      "iso38500",
      "iso27001",
      "iso26262",
      "pcidss",
      "hl7",
      "iso15408",
      "cra",
      "iso25024",
      "do178c",
      "sox",
      "ieee2857",
      "wcag22",
      "en301549",
      "iso24028",
      "iso25019",
      "iso29119",
      "eucsf"
    ],
    "excerpt": "How well does the system or product obeys the rules of a given standard."
  },
  {
    "id": "compliance-with-ui-styleguide",
    "label": "Compliance with UI styleguide",
    "labels": [
      "Compliance with UI styleguide"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/compliance-with-ui-styleguide"
  },
  {
    "id": "compliance-to-wcag",
    "label": "Compliance with WCAG accessibility guidelines",
    "labels": [
      "Compliance with WCAG accessibility guidelines"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/compliance-to-wcag"
  },
  {
    "id": "composability",
    "label": "Composability",
    "labels": [
      "Composability"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/composability",
    "excerpt": "Composability is a system design principle that deals with the inter-relationships of components. A highly composable system provides components that can be selected and assembled in various combinations to satisfy specific user requirement…"
  },
  {
    "id": "computational-overhead-reduction",
    "label": "Computational Overhead Reduction",
    "labels": [
      "Computational Overhead Reduction"
    ],
    "size": 20,
    "color": "#92ef80",
    "qualityType": "approach",
    "page": "/approaches/computational-overhead-reduction"
  },
  {
    "id": "conciseness",
    "label": "Conciseness",
    "labels": [
      "Conciseness"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/conciseness",
    "standards": [
      "iso26514",
      "iso42010"
    ],
    "excerpt": "Giving a lot of information clearly and in a few words; brief but comprehensive."
  },
  {
    "id": "confidentiality",
    "label": "Confidentiality",
    "labels": [
      "Confidentiality"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/confidentiality",
    "standards": [
      "iso25010",
      "iso27001",
      "pcidss",
      "hl7",
      "iso15408",
      "cra",
      "iec62443",
      "iso25024",
      "gdpr",
      "sox",
      "ieee2857",
      "etsien304223",
      "owaspasvs",
      "soc2",
      "dicom",
      "ihe"
    ],
    "excerpt": "Capability of a product to ensure that data are accessible only to those authorized to have access."
  },
  {
    "id": "confidentiality-by-multitenance",
    "label": "Confidentiality by multi-tenancy",
    "labels": [
      "Confidentiality by multi-tenancy"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/confidentiality-by-multitenance"
  },
  {
    "id": "configurability",
    "label": "Configurability",
    "labels": [
      "Configurability",
      "Tailorability"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/configurability",
    "standards": [
      "iso26262",
      "ieee2857"
    ],
    "excerpt": "Configurability refers to the ability of a system, software application, or hardware device to be easily customized and adapted to suit various requirements, preferences, and environments. A configurable system allows users or administrator…"
  },
  {
    "id": "configurable-ui-theme",
    "label": "Configurable UI theme",
    "labels": [
      "Configurable UI theme"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/configurable-ui-theme"
  },
  {
    "id": "consent-management",
    "label": "Consent Management",
    "labels": [
      "Consent Management"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/consent-management",
    "standards": [
      "gdpr",
      "ieee2857",
      "iso29100"
    ],
    "excerpt": "Consent management is the capability to obtain, record, update, and enforce user consent decisions for personal data processing."
  },
  {
    "id": "consistency",
    "label": "Consistency",
    "labels": [
      "Consistency",
      "Eventual Consistency"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/consistency",
    "standards": [
      "iso26514",
      "iso25024",
      "iso42010",
      "iso42030",
      "iso12207",
      "sox",
      "wcag22",
      "en301549",
      "iso8000"
    ],
    "excerpt": "Free from variation or contradiction"
  },
  {
    "id": "consistent-keyboard-shortcuts",
    "label": "Consistent keyboard shortcuts",
    "labels": [
      "Consistent keyboard shortcuts"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/consistent-keyboard-shortcuts"
  },
  {
    "id": "consumer-driven-contracts",
    "label": "Consumer-Driven Contracts",
    "labels": [
      "Consumer-Driven Contracts",
      "Contract Testing"
    ],
    "size": 20,
    "color": "#92ef80",
    "qualityType": "approach",
    "page": "/approaches/consumer-driven-contracts"
  },
  {
    "id": "content-delivery-network",
    "label": "Content Delivery Network (CDN)",
    "labels": [
      "Content Delivery Network (CDN)"
    ],
    "size": 20,
    "color": "#92ef80",
    "qualityType": "approach",
    "page": "/approaches/content-delivery-network"
  },
  {
    "id": "content-moderation-fairness",
    "label": "Content Moderation Fairness",
    "labels": [
      "Content Moderation Fairness"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/content-moderation-fairness"
  },
  {
    "id": "controllability",
    "label": "Controllability",
    "labels": [
      "Controllability",
      "User Controllability",
      "Human Controllability",
      "Human Oversight"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/controllability",
    "standards": [
      "ieee2857",
      "iso25059",
      "iso42001",
      "nistairmf"
    ],
    "excerpt": "The interface will allow the user to perceive that they are in control and will allow appropriate control."
  },
  {
    "id": "convenience",
    "label": "Convenience",
    "labels": [
      "Convenience"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/convenience",
    "excerpt": "... things the product shall do to simplify tasks, and to expedite and make the user/customer’s work easier and smoother."
  },
  {
    "id": "convenient-online-banking",
    "label": "Convenient online banking",
    "labels": [
      "Convenient online banking"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/convenient-online-banking"
  },
  {
    "id": "core-functions-on-mac-win-linux",
    "label": "Core functions can be used on multiple OSs",
    "labels": [
      "Core functions can be used on multiple OSs"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/core-functions-on-mac-win-linux"
  },
  {
    "id": "correctness",
    "label": "Correctness",
    "labels": [
      "Correctness",
      "Functional Correctness",
      "Truthfulness"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/correctness",
    "standards": [
      "iso26514",
      "iso12207",
      "sox",
      "iso8000",
      "iso29119",
      "iso25059"
    ],
    "excerpt": "Provide accurate results when used by intended users for intended functions. Sub-characteristic of functional suitability."
  },
  {
    "id": "cost",
    "label": "Cost",
    "labels": [
      "Cost"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/cost",
    "excerpt": "...the value of money that has been used up to produce something or deliver a service, and hence is not available for use anymore."
  },
  {
    "id": "cqrs",
    "label": "CQRS",
    "labels": [
      "CQRS"
    ],
    "size": 20,
    "color": "#92ef80",
    "qualityType": "approach",
    "page": "/approaches/cqrs"
  },
  {
    "id": "credibility",
    "label": "Credibility",
    "labels": [
      "Credibility"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/credibility",
    "standards": [
      "iso25024"
    ],
    "excerpt": "Credibility comprises the objective and subjective components of the believability of a source or message."
  },
  {
    "id": "credit-scoring-fairness",
    "label": "Credit Scoring Fairness",
    "labels": [
      "Credit Scoring Fairness"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/credit-scoring-fairness"
  },
  {
    "id": "crm-data-synchronization",
    "label": "CRM System Data Synchronization",
    "labels": [
      "CRM System Data Synchronization"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/crm-data-synchronization"
  },
  {
    "id": "cultural-sensitivity-in-content",
    "label": "Cultural Sensitivity in Content",
    "labels": [
      "Cultural Sensitivity in Content"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/cultural-sensitivity-in-content"
  },
  {
    "id": "customizability",
    "label": "Customizability",
    "labels": [
      "Customizability"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/customizability",
    "excerpt": "The ability of software to be changed by the user"
  },
  {
    "id": "cyber-security",
    "label": "Cyber Security",
    "labels": [
      "Cyber Security"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/cyber-security",
    "excerpt": "The term cyber security refers to all measures that serve to protect critical IT infrastructure, networks and data from digital attacks. The focus of cyber security or IT security is on defending against all digital attacks from internal or…"
  },
  {
    "id": "cycle-time",
    "label": "Cycle time",
    "labels": [
      "Cycle time"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/cycle-time",
    "excerpt": "Time a team spends working on an item until it is ready for shipment. In the development world, cycle time is the time from when developers make a commit to the moment it's deployed to production. This key DevOps metric helps project leads…"
  },
  {
    "id": "data-integrity",
    "label": "Data Integrity",
    "labels": [
      "Data Integrity"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/data-integrity",
    "standards": [
      "iso27001",
      "iso25024",
      "pcidss",
      "hl7",
      "nist80053",
      "iso15408",
      "gdpr",
      "sox",
      "ieee2857",
      "owaspasvs",
      "iso8000",
      "dicom",
      "ihe"
    ],
    "excerpt": "Data integrity refers to the maintenance and assurance of accuracy, consistency, and reliability of data over its entire life cycle. It ensures that data remains unaltered and consistent from creation to deletion, maintaining its original s…"
  },
  {
    "id": "data-localization",
    "label": "Data Localization",
    "labels": [
      "Data Localization"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/data-localization",
    "excerpt": "Data localization is the requirement that data about a nation's citizens or residents be collected, processed, and/or stored inside the country."
  },
  {
    "id": "data-localization-for-citizen-records",
    "label": "Data Localization for Citizen Records",
    "labels": [
      "Data Localization for Citizen Records"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/data-localization-for-citizen-records"
  },
  {
    "id": "data-minimization",
    "label": "Data Minimization",
    "labels": [
      "Data Minimization"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/data-minimization",
    "standards": [
      "gdpr",
      "ieee2857",
      "iso29100"
    ],
    "excerpt": "Data minimization means collecting and processing only the personal data that is necessary for a specific and legitimate purpose."
  },
  {
    "id": "data-protection",
    "label": "Data Protection",
    "labels": [
      "Data Protection"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/data-protection",
    "standards": [
      "gdpr",
      "ieee2857",
      "iso29100"
    ],
    "excerpt": "Data protection is the process of safeguarding important information from corruption, compromise or loss."
  },
  {
    "id": "data-quality",
    "label": "Data Quality",
    "labels": [
      "Data Quality"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/data-quality",
    "standards": [
      "iso42001",
      "hl7",
      "isoiec22989",
      "sox",
      "iso8000",
      "iso25012",
      "dicom",
      "ihe"
    ],
    "excerpt": "Data quality refers to the state of qualitative or quantitative pieces of information. Data is generally considered high quality if it is \"fit for its intended uses in operations, decision making and planning\". Data is deemed of high qualit…"
  },
  {
    "id": "data-replication",
    "label": "Data Replication",
    "labels": [
      "Data Replication",
      "Read Replicas"
    ],
    "size": 20,
    "color": "#92ef80",
    "qualityType": "approach",
    "page": "/approaches/data-replication"
  },
  {
    "id": "data-residency",
    "label": "Data Residency",
    "labels": [
      "Data Residency"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/data-residency",
    "standards": [
      "c3a",
      "eucsf"
    ],
    "excerpt": "Data residency is the physical or geographical location of an organization's digital information."
  },
  {
    "id": "data-sovereignty",
    "label": "Data Sovereignty",
    "labels": [
      "Data Sovereignty"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/data-sovereignty",
    "standards": [
      "c3a",
      "eucsf"
    ],
    "excerpt": "Data sovereignty means that data generated within a country's borders is governed by that nation's laws and regulatory frameworks; this ensures local control over data access, storage, and usage."
  },
  {
    "id": "data-throughput-for-visual-test-system",
    "label": "Data Throughput for Visual Test System",
    "labels": [
      "Data Throughput for Visual Test System"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/data-throughput-for-visual-test-system"
  },
  {
    "id": "database-sharding",
    "label": "Database Sharding",
    "labels": [
      "Database Sharding"
    ],
    "size": 20,
    "color": "#92ef80",
    "qualityType": "approach",
    "page": "/approaches/database-sharding"
  },
  {
    "id": "dead-mans-switch",
    "label": "Dead Man's Switch",
    "labels": [
      "Dead Man's Switch",
      "Vigilance Control",
      "Hold-to-Run",
      "Confirmed Commit"
    ],
    "size": 20,
    "color": "#92ef80",
    "qualityType": "approach",
    "page": "/approaches/dead-mans-switch"
  },
  {
    "id": "debuggability",
    "label": "Debuggability",
    "labels": [
      "Debuggability"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/debuggability",
    "excerpt": "Ability of a system to make defects and undesired behaviors easy to diagnose and localize in development, test, and production environments."
  },
  {
    "id": "defer-binding",
    "label": "Defer Binding",
    "labels": [
      "Defer Binding",
      "Late Binding",
      "Binding Time",
      "Deferred Binding"
    ],
    "size": 20,
    "color": "#92ef80",
    "qualityType": "approach",
    "page": "/approaches/defer-binding"
  },
  {
    "id": "dependability",
    "label": "Dependability",
    "labels": [
      "Dependability"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/dependability",
    "standards": [
      "iso26262",
      "cra",
      "iso25019"
    ],
    "excerpt": "Ability to perform as and when required."
  },
  {
    "id": "deployability",
    "label": "Deployability",
    "labels": [
      "Deployability"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/deployability",
    "standards": [
      "iso12207"
    ],
    "excerpt": "Deployability refers to a property of software indicating that it may be deployed, that is, allocated to an environment for execution—within a predictable and acceptable amount of time and effort. Moreover, if the new deployment is not meet…"
  },
  {
    "id": "deployment-frequency",
    "label": "Deployment frequency",
    "labels": [
      "Deployment frequency"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/deployment-frequency",
    "excerpt": "Deployment frequency: how often new code is deployed into production."
  },
  {
    "id": "detailed-audit-log",
    "label": "Detailed audit log",
    "labels": [
      "Detailed audit log"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/detailed-audit-log"
  },
  {
    "id": "detect-inconsistent-user-input",
    "label": "Detect inconsistent user input",
    "labels": [
      "Detect inconsistent user input"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/detect-inconsistent-user-input"
  },
  {
    "id": "determinism",
    "label": "Determinism",
    "labels": [
      "Determinism"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/determinism",
    "excerpt": "Determinism means that under the same inputs and initial conditions, a system produces the same externally observable behavior. This is foundational for reproducible testing, debugging, formal reasoning, and fault-tolerant replication."
  },
  {
    "id": "deterministic-behavior-for-medical-imaging",
    "label": "Deterministic behavior for medical imaging",
    "labels": [
      "Deterministic behavior for medical imaging"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/deterministic-behavior-for-medical-imaging"
  },
  {
    "id": "devops-metrics",
    "label": "Devops-Metrics",
    "labels": [
      "Devops-Metrics",
      "DORA"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/devops-metrics",
    "excerpt": "Lead time for changes: the length of time between when a code change is committed to the trunk branch and when it is in a deployable state. Change failure rate: the percentage of code changes that require hot fixes or other remediation afte…"
  },
  {
    "id": "diagnosability",
    "label": "Diagnosability",
    "labels": [
      "Diagnosability"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/diagnosability",
    "excerpt": "Diagnosability is the degree to which a system provides clear, accurate, and timely information to identify and localize the cause of a failure from its observed symptoms."
  },
  {
    "id": "dicom",
    "label": "DICOM — Digital Imaging and Communications in Medicine",
    "size": 45,
    "color": "#ffc95c",
    "qualityType": "standard",
    "page": "/standards/dicom"
  },
  {
    "id": "discoverability",
    "label": "Discoverability",
    "labels": [
      "Discoverability"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/discoverability",
    "excerpt": "The ease with which users can find new or unknown features, content, and functionalities within a product or system without prior knowledge of their existence."
  },
  {
    "id": "display-data-based-on-context",
    "label": "Display Data Based on Context",
    "labels": [
      "Display Data Based on Context"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/display-data-based-on-context"
  },
  {
    "id": "distributability",
    "label": "Distributability",
    "labels": [
      "Distributability"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/distributability",
    "excerpt": "In software engineering, distributability refers to the ease with which a system's components can be distributed across multiple physical or virtual locations, platforms, or computing nodes while maintaining functionality, performance, and…"
  },
  {
    "id": "do178c",
    "label": "DO-178C - Software Considerations in Airborne Systems and Equipment Certification",
    "size": 45,
    "color": "#ffc95c",
    "qualityType": "standard",
    "page": "/standards/do-178c"
  },
  {
    "id": "drift-detectability",
    "label": "Drift Detectability",
    "labels": [
      "Drift Detectability"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/drift-detectability",
    "standards": [
      "nistairmf",
      "iso24028",
      "etsien304223"
    ],
    "excerpt": "Drift detectability is a quality mainly relevant for long-running systems whose operating context, input data, users, environment, or learned model behavior can change after deployment."
  },
  {
    "id": "durability",
    "label": "Durability",
    "labels": [
      "Durability"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/durability",
    "excerpt": "Durability guarantees that once a transaction has been committed, it will remain committed even in the case of a system failure (e.g., power outage or crash)."
  },
  {
    "id": "ease-of-use",
    "label": "Ease of Use",
    "labels": [
      "Ease of Use"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/ease-of-use",
    "excerpt": "Ease of use is a basic concept that describes how easily users can use a product. Design teams define specific metrics per project—e.g., “Users must be able to tap Find within 3 seconds of accessing the interface.” —and aim to optimize ease…"
  },
  {
    "id": "change-cloud-provider",
    "label": "Easily change cloud provider",
    "labels": [
      "Easily change cloud provider"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/change-cloud-provider"
  },
  {
    "id": "easy-ui",
    "label": "Easy UI",
    "labels": [
      "Easy UI"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/easy-ui"
  },
  {
    "id": "effectiveness",
    "label": "Effectiveness",
    "labels": [
      "Effectiveness",
      "Efficacy"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/effectiveness",
    "standards": [
      "iso25022",
      "iso25019"
    ],
    "excerpt": "Effectiveness is the capability of producing a desired result or the ability to produce desired output."
  },
  {
    "id": "efficiency",
    "label": "Efficiency",
    "labels": [
      "Efficiency"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/efficiency",
    "standards": [
      "misra-c",
      "iso25022",
      "iso25019"
    ],
    "excerpt": "capable of producing desired results with little or no waste (as of time or materials)"
  },
  {
    "id": "luggage-routing",
    "label": "Efficient change of business rules",
    "labels": [
      "Efficient change of business rules"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/luggage-routing"
  },
  {
    "id": "efficient-generation-of-test-data",
    "label": "Efficient generation of test data",
    "labels": [
      "Efficient generation of test data"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/efficient-generation-of-test-data"
  },
  {
    "id": "efficient-save-function",
    "label": "Efficient save function",
    "labels": [
      "Efficient save function"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/efficient-save-function"
  },
  {
    "id": "annual-tax-update",
    "label": "Efficient update of annual accounting report",
    "labels": [
      "Efficient update of annual accounting report"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/annual-tax-update"
  },
  {
    "id": "elasticity",
    "label": "Elasticity",
    "labels": [
      "Elasticity"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/elasticity",
    "excerpt": "In distributed system and system resource, elasticity is defined as \"the degree to which a system is able to adapt to workload changes by provisioning and de-provisioning resources in an autonomic manner, such that at each point in time the…"
  },
  {
    "id": "employee-attempts-to-modify-pay-rate",
    "label": "Employee attempts to modify pay rate",
    "labels": [
      "Employee attempts to modify pay rate"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/employee-attempts-to-modify-pay-rate"
  },
  {
    "id": "en301549",
    "label": "EN 301 549 - Accessibility requirements for ICT products and services",
    "size": 45,
    "color": "#ffc95c",
    "qualityType": "standard",
    "page": "/standards/en-301-549"
  },
  {
    "id": "encrypted-storage",
    "label": "Encrypted storage",
    "labels": [
      "Encrypted storage"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/encrypted-storage"
  },
  {
    "id": "encryption-at-rest-and-in-transit",
    "label": "Encryption at Rest + in Transit",
    "labels": [
      "Encryption at Rest + in Transit"
    ],
    "size": 20,
    "color": "#92ef80",
    "qualityType": "approach",
    "page": "/approaches/encryption-at-rest-and-in-transit"
  },
  {
    "id": "energy-efficiency",
    "label": "Energy Efficiency",
    "labels": [
      "Energy Efficiency"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/energy-efficiency",
    "excerpt": "In the context of software engineering, \"energy efficiency\" refers to the ability of a software system to optimize its energy consumption while performing its intended tasks effectively. It involves designing and implementing software in a…"
  },
  {
    "id": "energy-proportionality",
    "label": "Energy Proportionality",
    "labels": [
      "Energy Proportionality"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/energy-proportionality",
    "excerpt": "Energy proportionality is a measure of the relationship between power consumed in a computer system, and the rate at which useful work is done (its utilization). If the overall power consumption is proportional to the computer's utilization…"
  },
  {
    "id": "etsien304223",
    "label": "ETSI EN 304 223 - AI Cybersecurity Baseline Requirements",
    "size": 45,
    "color": "#ffc95c",
    "qualityType": "standard",
    "page": "/standards/etsi-en-304-223"
  },
  {
    "id": "eucsf",
    "label": "EU CSF — Cloud Sovereignty Framework",
    "size": 45,
    "color": "#ffc95c",
    "qualityType": "standard",
    "page": "/standards/eu-cloud-sovereignty-framework"
  },
  {
    "id": "cra",
    "label": "EU Cyber Resilience Act (CRA) — Regulation 2024/2847",
    "size": 45,
    "color": "#ffc95c",
    "qualityType": "standard",
    "page": "/standards/cra"
  },
  {
    "id": "event-sourcing",
    "label": "Event Sourcing",
    "labels": [
      "Event Sourcing"
    ],
    "size": 20,
    "color": "#92ef80",
    "qualityType": "approach",
    "page": "/approaches/event-sourcing"
  },
  {
    "id": "event-driven-architecture",
    "label": "Event-Driven Architecture",
    "labels": [
      "Event-Driven Architecture"
    ],
    "size": 20,
    "color": "#92ef80",
    "qualityType": "approach",
    "page": "/approaches/event-driven-architecture"
  },
  {
    "id": "every-data-modification-is-logged",
    "label": "Every data modification is logged",
    "labels": [
      "Every data modification is logged"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/every-data-modification-is-logged"
  },
  {
    "id": "evolvability",
    "label": "Evolvability",
    "labels": [
      "Evolvability"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/evolvability",
    "excerpt": "The ability of a system to adapt to changes in its environment, requirements, and implementation technologies in a cost-effective way."
  },
  {
    "id": "expected-physical-environment",
    "label": "Expected physical environment",
    "labels": [
      "Expected physical environment"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/expected-physical-environment",
    "excerpt": "... specifies the physical environment in which the product will operate."
  },
  {
    "id": "explainability",
    "label": "Explainability",
    "labels": [
      "Explainability"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/explainability",
    "standards": [
      "iso42001",
      "isoiec22989",
      "iso24028",
      "nistairmf",
      "ieee7000"
    ],
    "excerpt": "A system S is explainable with respect to an aspect X of S relative to an addressee A in context C if and only if there is an entity E (the explainer) who, by giving a corpus of information I (the explanation of X), enables A to understand…"
  },
  {
    "id": "expressive-error-messages",
    "label": "Expressive error messages",
    "labels": [
      "Expressive error messages"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/expressive-error-messages"
  },
  {
    "id": "extensibility",
    "label": "Extensibility",
    "labels": [
      "Extensibility"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/extensibility",
    "standards": [
      "hl7",
      "dicom",
      "ihe"
    ],
    "excerpt": "Ability to add new features or functions to a system."
  },
  {
    "id": "externalized-business-rules",
    "label": "Externalized Business Rules",
    "labels": [
      "Externalized Business Rules",
      "Rule Engine",
      "Decision Tables"
    ],
    "size": 20,
    "color": "#92ef80",
    "qualityType": "approach",
    "page": "/approaches/externalized-business-rules"
  },
  {
    "id": "facial-recognition-bias-mitigation",
    "label": "Facial Recognition Bias Mitigation",
    "labels": [
      "Facial Recognition Bias Mitigation"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/facial-recognition-bias-mitigation"
  },
  {
    "id": "fail-safe",
    "label": "Fail safe",
    "labels": [
      "Fail safe"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/fail-safe",
    "standards": [
      "iso25010"
    ],
    "excerpt": "Capability of a product to automatically place itself in a safe operating mode, or to revert to a safe condition in the event of a failure"
  },
  {
    "id": "fail-safe-defaults",
    "label": "Fail-Safe Defaults",
    "labels": [
      "Fail-Safe Defaults"
    ],
    "size": 20,
    "color": "#92ef80",
    "qualityType": "approach",
    "page": "/approaches/fail-safe-defaults"
  },
  {
    "id": "failure-transparency",
    "label": "Failure Transparency",
    "labels": [
      "Failure Transparency"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/failure-transparency",
    "excerpt": "Failure transparency hides faults and recovery from users and applications so that a distributed system continues to operate correctly despite component failures."
  },
  {
    "id": "fairness",
    "label": "Fairness",
    "labels": [
      "Fairness"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/fairness",
    "standards": [
      "iso42001",
      "isoiec22989",
      "iso24028",
      "nistairmf",
      "ieee7000"
    ],
    "excerpt": "In machine learning, fairness refers to the absence of any prejudice or favoritism toward an individual or group based on their inherent or acquired characteristics; many formal criteria (e.g., demographic parity, equalized odds, equal oppo…"
  },
  {
    "id": "fast-accurate-sensor",
    "label": "Fast and accurate sensor",
    "labels": [
      "Fast and accurate sensor"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/fast-accurate-sensor"
  },
  {
    "id": "fast-creation-of-sales-report",
    "label": "Fast creation of sales report",
    "labels": [
      "Fast creation of sales report"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/fast-creation-of-sales-report"
  },
  {
    "id": "fast-deployment",
    "label": "Fast deployment",
    "labels": [
      "Fast deployment"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/fast-deployment"
  },
  {
    "id": "fast-rollout-of-changes",
    "label": "Fast rollout of changes",
    "labels": [
      "Fast rollout of changes"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/fast-rollout-of-changes"
  },
  {
    "id": "fast-shutdown-time",
    "label": "Fast shutdown time (less than 10 sec)",
    "labels": [
      "Fast shutdown time (less than 10 sec)"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/fast-shutdown-time"
  },
  {
    "id": "fast-startup-time",
    "label": "Fast startup time (less than 90 sec)",
    "labels": [
      "Fast startup time (less than 90 sec)"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/fast-startup-time"
  },
  {
    "id": "fault-isolation",
    "label": "Fault isolation",
    "labels": [
      "Fault isolation"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/fault-isolation",
    "standards": [
      "iso26262",
      "do178c"
    ],
    "excerpt": "Fault detection, isolation, and recovery (FDIR) is a subfield of control engineering which concerns itself with monitoring a system, identifying when a fault has occurred, and pinpointing the type of fault and its location. Two approaches c…"
  },
  {
    "id": "fault-tolerance",
    "label": "Fault tolerance",
    "labels": [
      "Fault tolerance"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/fault-tolerance",
    "standards": [
      "iso25010",
      "iso26262",
      "iec61508"
    ],
    "excerpt": "Capability of a product to operate as intended despite the presence of hardware or software faults."
  },
  {
    "id": "faultlessness",
    "label": "Faultlessness",
    "labels": [
      "Faultlessness"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/faultlessness",
    "standards": [
      "iso25010"
    ],
    "excerpt": "Capability of a product to perform specified functions without fault under normal operation."
  },
  {
    "id": "feature-degradation",
    "label": "Feature Degradation",
    "labels": [
      "Feature Degradation"
    ],
    "size": 20,
    "color": "#92ef80",
    "qualityType": "approach",
    "page": "/approaches/feature-degradation"
  },
  {
    "id": "feature-toggles",
    "label": "Feature Toggles",
    "labels": [
      "Feature Toggles"
    ],
    "size": 20,
    "color": "#92ef80",
    "qualityType": "approach",
    "page": "/approaches/feature-toggles"
  },
  {
    "id": "features",
    "label": "Features",
    "labels": [
      "Features"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/features",
    "excerpt": "A feature is a unique characteristic that a product has or should have."
  },
  {
    "id": "financial-data-accuracy",
    "label": "Financial Data Accuracy for Reporting",
    "labels": [
      "Financial Data Accuracy for Reporting"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/financial-data-accuracy"
  },
  {
    "id": "financial-transactions-are-acid-compliant",
    "label": "Financial transactions are ACID-compliant and fully reconcilable",
    "labels": [
      "Financial transactions are ACID-compliant and fully reconcilable"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/financial-transactions-are-acid-compliant"
  },
  {
    "id": "fine-grained-authorization",
    "label": "Fine-Grained Authorization (RBAC/ABAC)",
    "labels": [
      "Fine-Grained Authorization (RBAC/ABAC)"
    ],
    "size": 20,
    "color": "#92ef80",
    "qualityType": "approach",
    "page": "/approaches/fine-grained-authorization"
  },
  {
    "id": "first-time-onboarding-without-errors",
    "label": "First-time onboarding without errors",
    "labels": [
      "First-time onboarding without errors"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/first-time-onboarding-without-errors"
  },
  {
    "id": "fleet-ota-updates-with-safe-rollback",
    "label": "Fleet OTA updates with safe rollback",
    "labels": [
      "Fleet OTA updates with safe rollback"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/fleet-ota-updates-with-safe-rollback"
  },
  {
    "id": "flexibility",
    "label": "Flexibility",
    "labels": [
      "Flexibility"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/flexibility",
    "standards": [
      "iso25010",
      "misra-c",
      "hl7",
      "iso42030",
      "iso12207",
      "ieee2857",
      "wcag22",
      "en301549",
      "dicom",
      "ihe"
    ],
    "excerpt": "serve a different or expanded set of requirements; work with different infrastructures or environments"
  },
  {
    "id": "fraud-detection-drift-detected-within-1-hour",
    "label": "Fraud detection drift detected within 1 hour",
    "labels": [
      "Fraud detection drift detected within 1 hour"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/fraud-detection-drift-detected-within-1-hour"
  },
  {
    "id": "functional-adaptability",
    "label": "Functional Adaptability",
    "labels": [
      "Functional Adaptability"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/functional-adaptability",
    "standards": [
      "iso25059"
    ],
    "excerpt": "Degree to which an AI system can accurately acquire information from data, or the result of previous actions, and use that information in future predictions."
  },
  {
    "id": "functional-appropriateness",
    "label": "Functional Appropriateness",
    "labels": [
      "Functional Appropriateness"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/functional-appropriateness",
    "standards": [
      "iso25010"
    ],
    "excerpt": "Provide functions that avoid behaviours or interactions that are irrelevant to accomplishing a specific task under specified conditions and do not provide functions that are not."
  },
  {
    "id": "functional-completeness",
    "label": "Functional completeness",
    "labels": [
      "Functional completeness"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/functional-completeness",
    "standards": [
      "iso25010",
      "iso42010",
      "iso42030",
      "iso12207",
      "sox"
    ],
    "excerpt": "Provide a set of functions that covers all the specified tasks and intended users’ objectives."
  },
  {
    "id": "functional-suitability",
    "label": "Functional suitability",
    "labels": [
      "Functional suitability"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/functional-suitability",
    "standards": [
      "iso25010"
    ],
    "excerpt": "Provide functions that meet stated and implied needs of intended users when it is used under specified conditions."
  },
  {
    "id": "functionality",
    "label": "Functionality",
    "labels": [
      "Functionality"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/functionality",
    "excerpt": "Functionality is the ability of the system to do the work for which it was intended."
  },
  {
    "id": "gdpr",
    "label": "GDPR - General Data Protection Regulation",
    "size": 45,
    "color": "#ffc95c",
    "qualityType": "standard",
    "page": "/standards/gdpr"
  },
  {
    "id": "global-explainability",
    "label": "Global Explainability",
    "labels": [
      "Global Explainability"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/global-explainability"
  },
  {
    "id": "good-code-readability-score",
    "label": "Good code readability score",
    "labels": [
      "Good code readability score"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/good-code-readability-score"
  },
  {
    "id": "governability",
    "label": "Governability",
    "labels": [
      "Governability",
      "Policy Enforcement"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/governability",
    "standards": [
      "iso38500",
      "iso42001",
      "iso42030",
      "iso27001",
      "nist80053"
    ],
    "excerpt": "Governance of IT is the system by which the current and future use of IT is directed and controlled."
  },
  {
    "id": "governance-policy-enforcement",
    "label": "Governance policies are enforced and auditable",
    "labels": [
      "Governance policies are enforced and auditable"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/governance-policy-enforcement"
  },
  {
    "id": "graceful-degradation",
    "label": "Graceful degradation",
    "labels": [
      "Graceful degradation"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/graceful-degradation",
    "excerpt": "The ability of maintaining functionality when portions of a system break down."
  },
  {
    "id": "grounded-explainable-loan-decision",
    "label": "Grounded and explainable loan decision",
    "labels": [
      "Grounded and explainable loan decision"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/grounded-explainable-loan-decision"
  },
  {
    "id": "grounded-customer-support-answer",
    "label": "Grounded customer support answer",
    "labels": [
      "Grounded customer support answer"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/grounded-customer-support-answer"
  },
  {
    "id": "grounded-medical-triage-draft",
    "label": "Grounded medical triage draft",
    "labels": [
      "Grounded medical triage draft"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/grounded-medical-triage-draft"
  },
  {
    "id": "groundedness",
    "label": "Groundedness",
    "labels": [
      "Groundedness"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/groundedness",
    "standards": [
      "nistairmf",
      "iso24028"
    ],
    "excerpt": "Groundedness is a quality mainly relevant for generative AI systems, retrieval-augmented generation (RAG), summarization, question answering, assistants, and agents that produce factual claims from supplied or retrieved context."
  },
  {
    "id": "handle-sudden-increase-in-traffic",
    "label": "Handle sudden increase in traffic",
    "labels": [
      "Handle sudden increase in traffic"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/handle-sudden-increase-in-traffic"
  },
  {
    "id": "hazard-warning",
    "label": "Hazard warning",
    "labels": [
      "Hazard warning"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/hazard-warning",
    "standards": [
      "iso25010"
    ],
    "excerpt": "A hazard is a potential source of harm. Substances, events, or circumstances can constitute hazards when their nature would allow them, even just theoretically, to cause damage to health, life, property, or any other interest of value."
  },
  {
    "id": "hexagonal-architecture",
    "label": "Hexagonal Architecture",
    "labels": [
      "Hexagonal Architecture",
      "Ports and Adapters",
      "Clean Architecture"
    ],
    "size": 20,
    "color": "#92ef80",
    "qualityType": "approach",
    "page": "/approaches/hexagonal-architecture"
  },
  {
    "id": "hiring-algorithm-bias-mitigation",
    "label": "Hiring Algorithm Bias Mitigation",
    "labels": [
      "Hiring Algorithm Bias Mitigation"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/hiring-algorithm-bias-mitigation"
  },
  {
    "id": "hl7",
    "label": "HL7 — Health Level Seven International (V2, CDA, FHIR)",
    "size": 45,
    "color": "#ffc95c",
    "qualityType": "standard",
    "page": "/standards/hl7"
  },
  {
    "id": "iec61508",
    "label": "IEC 61508 - Functional safety of E/E/PE safety-related systems",
    "size": 45,
    "color": "#ffc95c",
    "qualityType": "standard",
    "page": "/standards/iec-61508"
  },
  {
    "id": "iec62304",
    "label": "IEC 62304 - Medical device software",
    "size": 45,
    "color": "#ffc95c",
    "qualityType": "standard",
    "page": "/standards/iec-62304"
  },
  {
    "id": "iec62443",
    "label": "IEC 62443 - Security for Industrial Automation and Control Systems",
    "size": 45,
    "color": "#ffc95c",
    "qualityType": "standard",
    "page": "/standards/iec-62443"
  },
  {
    "id": "ieee2857",
    "label": "IEEE 2857 - Privacy Engineering Guidelines",
    "size": 45,
    "color": "#ffc95c",
    "qualityType": "standard",
    "page": "/standards/ieee-2857"
  },
  {
    "id": "ieee7000",
    "label": "IEEE 7000-2021 — Ethical Concerns in System Design",
    "size": 45,
    "color": "#ffc95c",
    "qualityType": "standard",
    "page": "/standards/ieee-7000"
  },
  {
    "id": "ihe",
    "label": "IHE — Integrating the Healthcare Enterprise",
    "size": 45,
    "color": "#ffc95c",
    "qualityType": "standard",
    "page": "/standards/ihe"
  },
  {
    "id": "immunity",
    "label": "Immunity",
    "labels": [
      "Immunity"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/immunity",
    "excerpt": "... what the product has to do to protect itself from infection by unauthorized or undesirable software programs, such as viruses, worms, malware, spyware and any other undesirable interference."
  },
  {
    "id": "inclusive-user-testing",
    "label": "Inclusive User Testing",
    "labels": [
      "Inclusive User Testing"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/inclusive-user-testing"
  },
  {
    "id": "inclusivity",
    "label": "Inclusivity",
    "labels": [
      "Inclusivity"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/inclusivity",
    "standards": [
      "iso25010",
      "wcag22",
      "en301549"
    ],
    "excerpt": "Capability of a product to be utilised by people of various backgrounds"
  },
  {
    "id": "increase-cohesion",
    "label": "Increase Cohesion",
    "labels": [
      "Increase Cohesion",
      "Split Module",
      "Redistribute Responsibilities"
    ],
    "size": 20,
    "color": "#92ef80",
    "qualityType": "approach",
    "page": "/approaches/increase-cohesion"
  },
  {
    "id": "independence",
    "label": "Independence",
    "labels": [
      "Independence"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/independence",
    "excerpt": "Functional independence is achieved by developing functions that perform only one kind of task and do not excessively interact with other modules. Independence is important because it makes implementation more accessible and faster. The ind…"
  },
  {
    "id": "independent-enhancement-of-subsystem",
    "label": "Independent enhancement of subsystem",
    "labels": [
      "Independent enhancement of subsystem"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/independent-enhancement-of-subsystem"
  },
  {
    "id": "independent-replacement-of-subsystem",
    "label": "Independent replacement of subsystem",
    "labels": [
      "Independent replacement of subsystem"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/independent-replacement-of-subsystem"
  },
  {
    "id": "injection-resistance",
    "label": "Injection Resistance",
    "labels": [
      "Injection Resistance"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/injection-resistance",
    "standards": [
      "owaspasvs",
      "etsien304223"
    ],
    "excerpt": "An attack which exploits the concatenation of untrusted input with a prompt constructed by a higher-trust party such as the application designer."
  },
  {
    "id": "input-sanitization-output-encoding",
    "label": "Input Sanitization / Output Encoding",
    "labels": [
      "Input Sanitization / Output Encoding"
    ],
    "size": 20,
    "color": "#92ef80",
    "qualityType": "approach",
    "page": "/approaches/input-sanitization-output-encoding"
  },
  {
    "id": "installability",
    "label": "Installability",
    "labels": [
      "Installability"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/installability",
    "standards": [
      "iso25010"
    ],
    "excerpt": "Capability of a product to be effectively and efficiently installed successfully and/or uninstalled in a specified environment"
  },
  {
    "id": "integrability",
    "label": "Integrability",
    "labels": [
      "Integrability"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/integrability",
    "excerpt": "Integrability is the ease with which a software component or system can be integrated with other components or systems."
  },
  {
    "id": "integrity",
    "label": "Integrity",
    "labels": [
      "Integrity"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/integrity",
    "standards": [
      "iso25010",
      "iso27001",
      "iso26262",
      "misra-c",
      "nist80053",
      "pcidss",
      "hl7",
      "iso15408",
      "cra",
      "iec62443",
      "iso25024",
      "do178c",
      "ieee2857",
      "etsien304223",
      "dicom",
      "ihe"
    ],
    "excerpt": "Capability of a product to ensure that the state of its system and data are protected from unauthorized modification or deletion either by malicious action or computer error"
  },
  {
    "id": "interaction-capability",
    "label": "Interaction capability",
    "labels": [
      "Interaction capability"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/interaction-capability",
    "standards": [
      "iso25010",
      "wcag22",
      "en301549"
    ],
    "excerpt": "capability of a product to be interacted with by specified users to exchange information between a user and a system via the user interface to complete the intended task"
  },
  {
    "id": "interchangeability",
    "label": "Interchangeability",
    "labels": [
      "Interchangeability"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/interchangeability",
    "excerpt": "Interchangeability is the ability to substitute one component, part, or element with another of the same type without requiring modifications to the system or loss of functionality."
  },
  {
    "id": "internationalization",
    "label": "Internationalization",
    "labels": [
      "Internationalization",
      "I18n"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/internationalization",
    "excerpt": "Developing information so that it is suitable for an international audience"
  },
  {
    "id": "interoperability",
    "label": "Interoperability",
    "labels": [
      "Interoperability"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/interoperability",
    "standards": [
      "iso25010",
      "hl7",
      "cra",
      "iso25024",
      "iso42030",
      "iso12207",
      "ieee2857",
      "wcag22",
      "en301549",
      "iso29100",
      "dicom",
      "ihe"
    ],
    "excerpt": "Capability of a product to exchange information with other products and mutually use the information that has been exchanged."
  },
  {
    "id": "interoperable-with-java-12",
    "label": "Interoperable with Java 12",
    "labels": [
      "Interoperable with Java 12"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/interoperable-with-java-12"
  },
  {
    "id": "interruptable-backend-process",
    "label": "Interruptable backend process",
    "labels": [
      "Interruptable backend process"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/interruptable-backend-process"
  },
  {
    "id": "intervenability",
    "label": "Intervenability",
    "labels": [
      "Intervenability"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/intervenability",
    "standards": [
      "iso25059"
    ],
    "excerpt": "Intervene as an operator in an AI system’s functioning in a timely manner to prevent harm or hazard."
  },
  {
    "id": "intrusion-detection",
    "label": "Intrusion Detection",
    "labels": [
      "Intrusion Detection"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/intrusion-detection",
    "standards": [
      "owaspasvs"
    ],
    "excerpt": "Intrusion detection is the process of monitoring the events occurring in a computer system or network and analyzing them for signs of possible incidents, which are violations or imminent threats of violation of computer security policies, a…"
  },
  {
    "id": "intrusion-prevention",
    "label": "Intrusion Prevention",
    "labels": [
      "Intrusion Prevention"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/intrusion-prevention",
    "standards": [
      "owaspasvs"
    ],
    "excerpt": "Intrusion prevention is the process of performing intrusion detection and attempting to stop detected possible incidents."
  },
  {
    "id": "intuitiveness",
    "label": "Intuitiveness",
    "labels": [
      "Intuitiveness"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/intuitiveness",
    "excerpt": "The degree to which a system's interface, behavior, and information organization align with users' existing mental models and expectations, enabling immediate understanding and effective use without prior learning or training."
  },
  {
    "id": "iso26262",
    "label": "ISO 26262 - Road vehicles — Functional safety",
    "size": 45,
    "color": "#ffc95c",
    "qualityType": "standard",
    "page": "/standards/iso-26262"
  },
  {
    "id": "iso8000",
    "label": "ISO 8000 — Data Quality",
    "size": 45,
    "color": "#ffc95c",
    "qualityType": "standard",
    "page": "/standards/iso-8000"
  },
  {
    "id": "isoiec12792",
    "label": "ISO/IEC 12792 - AI transparency taxonomy",
    "size": 45,
    "color": "#ffc95c",
    "qualityType": "standard",
    "page": "/standards/iso-iec-12792"
  },
  {
    "id": "iso14756",
    "label": "ISO/IEC 14756 - Measurement and Rating of Performance of Computer-Based Software Systems",
    "size": 45,
    "color": "#ffc95c",
    "qualityType": "standard",
    "page": "/standards/iso-iec-14756"
  },
  {
    "id": "iso15408",
    "label": "ISO/IEC 15408 - Common Criteria for IT Security",
    "size": 45,
    "color": "#ffc95c",
    "qualityType": "standard",
    "page": "/standards/iso-15408"
  },
  {
    "id": "isoiec22989",
    "label": "ISO/IEC 22989 - AI concepts and terminology",
    "size": 45,
    "color": "#ffc95c",
    "qualityType": "standard",
    "page": "/standards/iso-iec-22989"
  },
  {
    "id": "iso25010",
    "label": "ISO/IEC 25010 - Systems and Software Quality",
    "size": 45,
    "color": "#ffc95c",
    "qualityType": "standard",
    "page": "/standards/iso-25010"
  },
  {
    "id": "iso25012",
    "label": "ISO/IEC 25012 - Data Quality Model",
    "size": 45,
    "color": "#ffc95c",
    "qualityType": "standard",
    "page": "/standards/iso-iec-25012"
  },
  {
    "id": "iso25019",
    "label": "ISO/IEC 25019 - Quality-in-use model",
    "size": 45,
    "color": "#ffc95c",
    "qualityType": "standard",
    "page": "/standards/iso-25019"
  },
  {
    "id": "iso25022",
    "label": "ISO/IEC 25022 - Measurement of quality in use",
    "size": 45,
    "color": "#ffc95c",
    "qualityType": "standard",
    "page": "/standards/iso-25022"
  },
  {
    "id": "iso25024",
    "label": "ISO/IEC 25024 - Measurement of Data Quality",
    "size": 45,
    "color": "#ffc95c",
    "qualityType": "standard",
    "page": "/standards/iso-25024"
  },
  {
    "id": "iso25059",
    "label": "ISO/IEC 25059 - Systems and Software Quality — Quality models for AI systems",
    "size": 45,
    "color": "#ffc95c",
    "qualityType": "standard",
    "page": "/standards/iso-25059"
  },
  {
    "id": "iso27001",
    "label": "ISO/IEC 27001 - Information security management",
    "size": 45,
    "color": "#ffc95c",
    "qualityType": "standard",
    "page": "/standards/iso-27001"
  },
  {
    "id": "iso29100",
    "label": "ISO/IEC 29100 - Privacy Framework",
    "size": 45,
    "color": "#ffc95c",
    "qualityType": "standard",
    "page": "/standards/iso-iec-29100"
  },
  {
    "id": "iso38500",
    "label": "ISO/IEC 38500 - Governance of IT for the Organization",
    "size": 45,
    "color": "#ffc95c",
    "qualityType": "standard",
    "page": "/standards/iso-38500"
  },
  {
    "id": "iso42001",
    "label": "ISO/IEC 42001 - Artificial Intelligence Management System",
    "size": 45,
    "color": "#ffc95c",
    "qualityType": "standard",
    "page": "/standards/iso-42001"
  },
  {
    "id": "iso5055",
    "label": "ISO/IEC 5055 - Automated Source Code Quality Measures",
    "size": 45,
    "color": "#ffc95c",
    "qualityType": "standard",
    "page": "/standards/iso-5055"
  },
  {
    "id": "iso24028",
    "label": "ISO/IEC TR 24028 - Overview of trustworthiness in artificial intelligence",
    "size": 45,
    "color": "#ffc95c",
    "qualityType": "standard",
    "page": "/standards/iso-24028"
  },
  {
    "id": "iso12207",
    "label": "ISO/IEC/IEEE 12207 - Software Life Cycle Processes",
    "size": 45,
    "color": "#ffc95c",
    "qualityType": "standard",
    "page": "/standards/iso12207"
  },
  {
    "id": "iso26514",
    "label": "ISO/IEC/IEEE 26514 - Design and Development of Information for Users",
    "size": 45,
    "color": "#ffc95c",
    "qualityType": "standard",
    "page": "/standards/iso-26514"
  },
  {
    "id": "iso29119",
    "label": "ISO/IEC/IEEE 29119 - Software Testing",
    "size": 45,
    "color": "#ffc95c",
    "qualityType": "standard",
    "page": "/standards/iso-iec-ieee-29119"
  },
  {
    "id": "iso42010",
    "label": "ISO/IEC/IEEE 42010 - Architecture Description",
    "size": 45,
    "color": "#ffc95c",
    "qualityType": "standard",
    "page": "/standards/iso-42010"
  },
  {
    "id": "iso42030",
    "label": "ISO/IEC/IEEE 42030 - Architecture Evaluation",
    "size": 45,
    "color": "#ffc95c",
    "qualityType": "standard",
    "page": "/standards/iso-iec-ieee-42030"
  },
  {
    "id": "jitter",
    "label": "Jitter",
    "labels": [
      "Jitter"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/jitter",
    "excerpt": "In electronics and telecommunications, jitter is the deviation from true periodicity of a presumably periodic signal, often in relation to a reference clock signal."
  },
  {
    "id": "keep-data-on-error",
    "label": "Keep data on error",
    "labels": [
      "Keep data on error"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/keep-data-on-error"
  },
  {
    "id": "latency",
    "label": "Latency",
    "labels": [
      "Latency"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/latency",
    "standards": [
      "iso14756"
    ],
    "excerpt": "Latency in general is a time delay between the cause and the effect of some change in a system."
  },
  {
    "id": "lead-time-for-changes",
    "label": "Lead time for changes",
    "labels": [
      "Lead time for changes"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/lead-time-for-changes",
    "excerpt": "Lead time for changes: the length of time between when a code change is committed to the trunk branch and when it is in a deployable state. Not to be confused with cycle time, lead time for changes is the length of time between when a code…"
  },
  {
    "id": "learnability",
    "label": "Learnability",
    "labels": [
      "Learnability"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/learnability",
    "standards": [
      "iso25010",
      "ieee2857"
    ],
    "excerpt": "Capability of a product to have specified users learn to use specified product functions within a specified amount of time."
  },
  {
    "id": "least-privilege",
    "label": "Least Privilege",
    "labels": [
      "Least Privilege",
      "Limit Access"
    ],
    "size": 20,
    "color": "#92ef80",
    "qualityType": "approach",
    "page": "/approaches/least-privilege"
  },
  {
    "id": "legal-requirements",
    "label": "Legal Requirements",
    "labels": [
      "Legal Requirements"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/legal-requirements",
    "excerpt": "Legal Requirement means any federal, state, local, municipal, foreign or other law, statute, constitution, principle of common law, resolution, ordinance, code, edict, decree, rule, regulation, ruling or requirement issued, enacted, adopted…"
  },
  {
    "id": "legibility",
    "label": "Legibility",
    "labels": [
      "Legibility"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/legibility",
    "excerpt": "The fact of being easy to read, or the degree to which something is easy to read."
  },
  {
    "id": "limit-event-response",
    "label": "Limit Event Response",
    "labels": [
      "Limit Event Response"
    ],
    "size": 20,
    "color": "#92ef80",
    "qualityType": "approach",
    "page": "/approaches/limit-event-response"
  },
  {
    "id": "local-explainability",
    "label": "Local Explainability",
    "labels": [
      "Local Explainability"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/local-explainability"
  },
  {
    "id": "localizability",
    "label": "Localizability",
    "labels": [
      "Localizability"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/localizability",
    "excerpt": "In computing, internationalization and localization (American) or internationalisation and localisation (British English), often abbreviated i18n and L10n, are means of adapting computer software to different languages, regional peculiariti…"
  },
  {
    "id": "localizable-to-n-languages",
    "label": "Localizable to several languages",
    "labels": [
      "Localizable to several languages"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/localizable-to-n-languages"
  },
  {
    "id": "longevity",
    "label": "Longevity",
    "labels": [
      "Longevity"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/longevity",
    "excerpt": "This specifies the expected lifetime of the product."
  },
  {
    "id": "loose-coupling",
    "label": "Loose Coupling",
    "labels": [
      "Loose Coupling"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/loose-coupling",
    "excerpt": "In computing and systems design, a loosely coupled system is one"
  },
  {
    "id": "low-change-failure-rate",
    "label": "Low change-failure rate",
    "labels": [
      "Low change-failure rate"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/low-change-failure-rate"
  },
  {
    "id": "low-effort-deployment",
    "label": "Low effort deployment",
    "labels": [
      "Low effort deployment"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/low-effort-deployment"
  },
  {
    "id": "low-impact-diagnosis",
    "label": "Low impact diagnosis",
    "labels": [
      "Low impact diagnosis"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/low-impact-diagnosis"
  },
  {
    "id": "query-execution-management",
    "label": "Low-overhead query execution measurement",
    "labels": [
      "Low-overhead query execution measurement"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/query-execution-management"
  },
  {
    "id": "maintainability",
    "label": "Maintainability",
    "labels": [
      "Maintainability",
      "Supportability"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/maintainability",
    "standards": [
      "iso25010",
      "iso26262",
      "misra-c",
      "nist80053",
      "iso5055",
      "iec62304",
      "iec61508",
      "hl7",
      "cra",
      "isoiec22989",
      "do178c",
      "iso42010",
      "iso42030",
      "iso12207",
      "iso29119",
      "ieee2857",
      "iso24028",
      "etsien304223",
      "dicom",
      "ihe"
    ],
    "excerpt": "Maintainability is concerned with modifications after the software baseline is established."
  },
  {
    "id": "maintainable-checking-strategy",
    "label": "Maintainable checking strategies",
    "labels": [
      "Maintainable checking strategies"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/maintainable-checking-strategy"
  },
  {
    "id": "manage-event-arrival",
    "label": "Manage Event Arrival",
    "labels": [
      "Manage Event Arrival",
      "Service-Level Agreement"
    ],
    "size": 20,
    "color": "#92ef80",
    "qualityType": "approach",
    "page": "/approaches/manage-event-arrival"
  },
  {
    "id": "mean-time-between-failures",
    "label": "Mean time between failures",
    "labels": [
      "Mean time between failures"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/mean-time-between-failures",
    "excerpt": "Mean time between failures (MTBF) is the predicted elapsed time between inherent failures of a mechanical or electronic system during normal system operation."
  },
  {
    "id": "mean-time-to-recovery",
    "label": "Mean time to recovery",
    "labels": [
      "Mean time to recovery"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/mean-time-to-recovery",
    "excerpt": "Mean time to recovery (MTTR) measures how long it takes to recover from a partial service interruption or total failure."
  },
  {
    "id": "calibrated-medical-triage-confidence",
    "label": "Medical triage model confidence is calibrated",
    "labels": [
      "Medical triage model confidence is calibrated"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/calibrated-medical-triage-confidence"
  },
  {
    "id": "memory-usage",
    "label": "Memory usage",
    "labels": [
      "Memory usage"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/memory-usage",
    "excerpt": "A special case of resource utilization and resource-efficiency"
  },
  {
    "id": "microservice-architecture",
    "label": "Microservice Architecture",
    "labels": [
      "Microservice Architecture",
      "Microservices"
    ],
    "size": 20,
    "color": "#92ef80",
    "qualityType": "approach",
    "page": "/approaches/microservice-architecture"
  },
  {
    "id": "minimize-jitter",
    "label": "Minimize jitter in real-time data streaming",
    "labels": [
      "Minimize jitter in real-time data streaming"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/minimize-jitter"
  },
  {
    "id": "misra-c",
    "label": "MISRA C - Guidelines for the use of the C language in critical systems",
    "size": 45,
    "color": "#ffc95c",
    "qualityType": "standard",
    "page": "/standards/misra-c"
  },
  {
    "id": "model-transparency",
    "label": "Model Transparency",
    "labels": [
      "Model Transparency"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/model-transparency",
    "standards": [
      "isoiec12792",
      "isoiec22989",
      "iso24028",
      "nistairmf",
      "iso42001"
    ],
    "excerpt": "Model transparency is a quality of AI-enabled systems and machine-learning models."
  },
  {
    "id": "modifiability",
    "label": "Modifiability",
    "labels": [
      "Modifiability"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/modifiability",
    "standards": [
      "iso25010",
      "iso42010"
    ],
    "excerpt": "Capability of a system to be effectively and efficiently modified without introducing defects or degrading existing product quality"
  },
  {
    "id": "modular-system-for-data-analysis",
    "label": "Modular System for Data Analysis",
    "labels": [
      "Modular System for Data Analysis"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/modular-system-for-data-analysis"
  },
  {
    "id": "modularity",
    "label": "Modularity",
    "labels": [
      "Modularity"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/modularity",
    "standards": [
      "iso25010",
      "cra",
      "do178c",
      "iso42030",
      "iso12207",
      "ieee2857"
    ],
    "excerpt": "Capability of a product to limit changes to one component from affecting other components."
  },
  {
    "id": "monolith-loose-coupling-change-blast-radius",
    "label": "Monolith loose coupling: change blast radius",
    "labels": [
      "Monolith loose coupling: change blast radius"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/monolith-loose-coupling-change-blast-radius"
  },
  {
    "id": "multilinguality-support",
    "label": "Multilinguality Support",
    "labels": [
      "Multilinguality Support"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/multilinguality-support"
  },
  {
    "id": "n-version-redundancy",
    "label": "N-Version Redundancy and Voting",
    "labels": [
      "N-Version Redundancy and Voting",
      "Voting",
      "Masking",
      "Triple Modular Redundancy",
      "TMR",
      "N-Modular Redundancy"
    ],
    "size": 20,
    "color": "#92ef80",
    "qualityType": "approach",
    "page": "/approaches/n-version-redundancy"
  },
  {
    "id": "near-instant-search-results",
    "label": "Near instant search results",
    "labels": [
      "Near instant search results"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/near-instant-search-results"
  },
  {
    "id": "new-features-introduct-no-bugs",
    "label": "New Features Introduce No Bugs",
    "labels": [
      "New Features Introduce No Bugs"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/new-features-introduct-no-bugs"
  },
  {
    "id": "new-user-completes-core-tasks-without-training",
    "label": "New user completes core tasks without prior training",
    "labels": [
      "New user completes core tasks without prior training"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/new-user-completes-core-tasks-without-training"
  },
  {
    "id": "learnability-find-article",
    "label": "New users learn to find articles on their own",
    "labels": [
      "New users learn to find articles on their own"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/learnability-find-article"
  },
  {
    "id": "nistairmf",
    "label": "NIST AI RMF — Artificial Intelligence Risk Management Framework",
    "size": 45,
    "color": "#ffc95c",
    "qualityType": "standard",
    "page": "/standards/nist-ai-rmf"
  },
  {
    "id": "nistpf",
    "label": "NIST Privacy Framework — Managing Privacy Risk",
    "size": 45,
    "color": "#ffc95c",
    "qualityType": "standard",
    "page": "/standards/nist-privacy-framework"
  },
  {
    "id": "nist80053",
    "label": "NIST SP 800-53 — Security and Privacy Controls",
    "size": 45,
    "color": "#ffc95c",
    "qualityType": "standard",
    "page": "/standards/nist-800-53"
  },
  {
    "id": "non-repudiation",
    "label": "Non-repudiation",
    "labels": [
      "Non-repudiation"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/non-repudiation",
    "standards": [
      "iso25010",
      "iso27001",
      "pcidss",
      "owaspasvs",
      "soc2"
    ],
    "excerpt": "Capability of a product to prove that actions or events have taken place, so that the events or actions cannot be repudiated later."
  },
  {
    "id": "observability",
    "label": "Observability",
    "labels": [
      "Observability"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/observability",
    "standards": [
      "iso26262",
      "cra",
      "sox",
      "ieee2857"
    ],
    "excerpt": "Observability is a measure of how well internal states of a system can be inferred from knowledge of its external outputs."
  },
  {
    "id": "on-prem-installation-ready-in-30-min",
    "label": "On-prem installation ready in 30 minutes",
    "labels": [
      "On-prem installation ready in 30 minutes"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/on-prem-installation-ready-in-30-min"
  },
  {
    "id": "only-authenticated-users-can-access",
    "label": "Only authenticated users can access data",
    "labels": [
      "Only authenticated users can access data"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/only-authenticated-users-can-access"
  },
  {
    "id": "open-host-service",
    "label": "Open Host Service",
    "labels": [
      "Open Host Service",
      "Published Language"
    ],
    "size": 20,
    "color": "#92ef80",
    "qualityType": "approach",
    "page": "/approaches/open-host-service"
  },
  {
    "id": "operability",
    "label": "Operability",
    "labels": [
      "Operability"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/operability",
    "standards": [
      "iso25010",
      "nist80053",
      "wcag22",
      "en301549"
    ],
    "excerpt": "Capability of a product to have facilities and attributes that make it easy to operate and control."
  },
  {
    "id": "operational-environment-requirements",
    "label": "Operational and Environment Requirements",
    "labels": [
      "Operational and Environment Requirements"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/operational-environment-requirements",
    "excerpt": "Requirements for Interfacing with Adjacent Systems, Productization Requirements, Release Requirements, Backwards Compatibility Requirements"
  },
  {
    "id": "operational-constraint",
    "label": "Operational constraint",
    "labels": [
      "Operational constraint"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/operational-constraint",
    "standards": [
      "iso25010"
    ],
    "excerpt": "Capability of a product to constrain its operation to within safe parameters or states when encountering operational hazard."
  },
  {
    "id": "order-queue",
    "label": "Order queue",
    "labels": [
      "Order queue"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/order-queue"
  },
  {
    "id": "order-transaction-consistency",
    "label": "Order transaction consistency: no partial outcomes",
    "labels": [
      "Order transaction consistency: no partial outcomes"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/order-transaction-consistency"
  },
  {
    "id": "owaspasvs",
    "label": "OWASP Application Security Verification Standard (ASVS)",
    "size": 45,
    "color": "#ffc95c",
    "qualityType": "standard",
    "page": "/standards/owasp-asvs"
  },
  {
    "id": "parallel-data-modification",
    "label": "Parallel Data Modification",
    "labels": [
      "Parallel Data Modification"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/parallel-data-modification"
  },
  {
    "id": "patient-data-quality",
    "label": "Patient Data Quality in Healthcare System",
    "labels": [
      "Patient Data Quality in Healthcare System"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/patient-data-quality"
  },
  {
    "id": "patient-safety",
    "label": "Patient Safety",
    "labels": [
      "Patient Safety"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/patient-safety",
    "excerpt": "\"The absence of preventable harm to a patient and reduction of risk of unnecessary harm associated with health care to an acceptable minimum.\""
  },
  {
    "id": "pcidss",
    "label": "PCI Data Security Standard (PCI DSS)",
    "size": 45,
    "color": "#ffc95c",
    "qualityType": "standard",
    "page": "/standards/pci-dss"
  },
  {
    "id": "performance",
    "label": "Performance",
    "labels": [
      "Performance",
      "Performance Efficiency"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/performance",
    "standards": [
      "iso14756",
      "iso42030",
      "iso12207",
      "sox",
      "dicom"
    ],
    "excerpt": "Perform its functions within specified time and throughput parameters and be efficient in the use of resources under specified conditions"
  },
  {
    "id": "personalization",
    "label": "Personalization",
    "labels": [
      "Personalization"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/personalization",
    "excerpt": "\"... the way in which the product can be altered or configured to take into account the user’s personal preferences or choice of language. The personalization requirements should cover issues such as the following…"
  },
  {
    "id": "plugin-architecture",
    "label": "Plugin Architecture",
    "labels": [
      "Plugin Architecture",
      "Microkernel",
      "Add-in Architecture"
    ],
    "size": 20,
    "color": "#92ef80",
    "qualityType": "approach",
    "page": "/approaches/plugin-architecture"
  },
  {
    "id": "portability",
    "label": "Portability",
    "labels": [
      "Portability"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/portability",
    "standards": [
      "iso26262",
      "misra-c",
      "hl7",
      "iso25024",
      "dicom",
      "ihe",
      "eucsf"
    ],
    "excerpt": "A computer program is said to be portable if there is low effort required to make it run on different environments, operating systems, infrastructures or platforms."
  },
  {
    "id": "portable-business-data-checker",
    "label": "Portable Business Data Checker",
    "labels": [
      "Portable Business Data Checker"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/portable-business-data-checker"
  },
  {
    "id": "high-precision-calculation",
    "label": "Precise calculation of gamma coefficient",
    "labels": [
      "Precise calculation of gamma coefficient"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/high-precision-calculation"
  },
  {
    "id": "precision",
    "label": "Precision",
    "labels": [
      "Precision",
      "Preciseness"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/precision",
    "standards": [
      "iso25024"
    ],
    "excerpt": "Refers to how closely individual measurements agree with each other."
  },
  {
    "id": "precise-vehicle-orientation-gps",
    "label": "Precision of vehicle's orientation",
    "labels": [
      "Precision of vehicle's orientation"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/precise-vehicle-orientation-gps"
  },
  {
    "id": "predictability",
    "label": "Predictability",
    "labels": [
      "Predictability"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/predictability",
    "standards": [
      "misra-c"
    ],
    "excerpt": "Predictability is the degree to which a correct prediction or forecast of a system's state can be made, either qualitatively or quantitatively."
  },
  {
    "id": "preserve-facts-derive-interpretations",
    "label": "Preserve Facts, Derive Interpretations",
    "labels": [
      "Preserve Facts, Derive Interpretations",
      "Facts over State",
      "Semantic Deferral",
      "Business Uncertainty Tolerance"
    ],
    "size": 20,
    "color": "#92ef80",
    "qualityType": "approach",
    "page": "/approaches/preserve-facts-derive-interpretations"
  },
  {
    "id": "privacy",
    "label": "Privacy",
    "labels": [
      "Privacy"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/privacy",
    "standards": [
      "nist80053",
      "aiuc1",
      "isoiec22989",
      "gdpr",
      "ieee2857",
      "iso24028",
      "soc2",
      "nistairmf",
      "nistpf"
    ],
    "excerpt": "Broadly speaking, privacy is the right to be let alone, or freedom from interference or intrusion. Information privacy is the right to have some control over how your personal information is collected and used."
  },
  {
    "id": "production-anomalies-detectable-within-2-minutes",
    "label": "Production anomalies detectable within 2 minutes",
    "labels": [
      "Production anomalies detectable within 2 minutes"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/production-anomalies-detectable-within-2-minutes"
  },
  {
    "id": "profitability",
    "label": "Profitability",
    "labels": [
      "Profitability"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/profitability",
    "excerpt": "In economics, profit is the difference between revenue that an economic entity has received from its outputs and total costs of its inputs."
  },
  {
    "id": "progressive-disclosure",
    "label": "Progressive Disclosure",
    "labels": [
      "Progressive Disclosure"
    ],
    "size": 20,
    "color": "#92ef80",
    "qualityType": "approach",
    "page": "/approaches/progressive-disclosure"
  },
  {
    "id": "protect-data-by-security-procols",
    "label": "Protect Data by Establishing Security Protocols",
    "labels": [
      "Protect Data by Establishing Security Protocols"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/protect-data-by-security-procols"
  },
  {
    "id": "provability",
    "label": "Provability",
    "labels": [
      "Provability"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/provability",
    "excerpt": "The ability to demonstrate through rigorous, often mathematical, means that a piece of software meets specified quality requirements."
  },
  {
    "id": "provable-insulin-dosage-safety",
    "label": "Provable Insulin Dosage Safety",
    "labels": [
      "Provable Insulin Dosage Safety"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/provable-insulin-dosage-safety"
  },
  {
    "id": "provable-railway-interlocking-routing-logic",
    "label": "Provable railway interlocking routing logic",
    "labels": [
      "Provable railway interlocking routing logic"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/provable-railway-interlocking-routing-logic"
  },
  {
    "id": "provable-railway-interlocking-safety",
    "label": "Provable Railway Interlocking Safety",
    "labels": [
      "Provable Railway Interlocking Safety"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/provable-railway-interlocking-safety"
  },
  {
    "id": "public-api-intrusion-attempts-blocked",
    "label": "Public API intrusion attempts blocked and alerted",
    "labels": [
      "Public API intrusion attempts blocked and alerted"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/public-api-intrusion-attempts-blocked"
  },
  {
    "id": "quarantine",
    "label": "Quarantine",
    "labels": [
      "Quarantine",
      "Removal from Service"
    ],
    "size": 20,
    "color": "#92ef80",
    "qualityType": "approach",
    "page": "/approaches/quarantine"
  },
  {
    "id": "quick-unit-tests",
    "label": "Quick unit tests",
    "labels": [
      "Quick unit tests"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/quick-unit-tests"
  },
  {
    "id": "quickly-locate-bugs",
    "label": "Quickly locate bugs",
    "labels": [
      "Quickly locate bugs"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/quickly-locate-bugs"
  },
  {
    "id": "rate-limiting",
    "label": "Rate Limiting",
    "labels": [
      "Rate Limiting",
      "Throttling"
    ],
    "size": 20,
    "color": "#92ef80",
    "qualityType": "approach",
    "page": "/approaches/rate-limiting"
  },
  {
    "id": "readability",
    "label": "Readability",
    "labels": [
      "Readability"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/readability",
    "excerpt": "The fact of being easy to read, or the degree to which something is easy to read."
  },
  {
    "id": "recognize-assistive-technology",
    "label": "Recognize Assistive Technologies",
    "labels": [
      "Recognize Assistive Technologies"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/recognize-assistive-technology"
  },
  {
    "id": "reconciliation-loops",
    "label": "Reconciliation Loops",
    "labels": [
      "Reconciliation Loops",
      "Controller Pattern",
      "Reconciler Pattern"
    ],
    "size": 20,
    "color": "#92ef80",
    "qualityType": "approach",
    "page": "/approaches/reconciliation-loops"
  },
  {
    "id": "recoverability",
    "label": "Recoverability",
    "labels": [
      "Recoverability",
      "Recovery Time"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/recoverability",
    "standards": [
      "iso25010",
      "cra",
      "iso25024",
      "sox",
      "etsien304223"
    ],
    "excerpt": "capability of a product in the event of an interruption or a failure to recover the data directly affected and re-establish the desired state of the system."
  },
  {
    "id": "reduce-coupling",
    "label": "Reduce Coupling",
    "labels": [
      "Reduce Coupling",
      "Decoupling",
      "Dependency Reduction"
    ],
    "size": 20,
    "color": "#92ef80",
    "qualityType": "approach",
    "page": "/approaches/reduce-coupling"
  },
  {
    "id": "reduce-energy-consumption-with-new-version",
    "label": "Reduce energy consumption with every new version",
    "labels": [
      "Reduce energy consumption with every new version"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/reduce-energy-consumption-with-new-version"
  },
  {
    "id": "redundancy",
    "label": "Redundancy",
    "labels": [
      "Redundancy"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/redundancy",
    "excerpt": "The term can be interpreted in two different directions…"
  },
  {
    "id": "reinterpret-domain-concept-from-historical-facts",
    "label": "Reinterpret a domain concept from historical facts",
    "labels": [
      "Reinterpret a domain concept from historical facts"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/reinterpret-domain-concept-from-historical-facts"
  },
  {
    "id": "releasability",
    "label": "Releasability",
    "labels": [
      "Releasability"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/releasability",
    "excerpt": "...the intended release cycle for the product and the form that the release shall take."
  },
  {
    "id": "reliability",
    "label": "Reliability",
    "labels": [
      "Reliability"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/reliability",
    "standards": [
      "iso25010",
      "iso27001",
      "iso26262",
      "misra-c",
      "nist80053",
      "iso5055",
      "iso14756",
      "aiuc1",
      "iec62304",
      "iec61508",
      "hl7",
      "iso15408",
      "cra",
      "isoiec22989",
      "iso25024",
      "do178c",
      "iso42030",
      "iso12207",
      "iso29119",
      "sox",
      "nistairmf",
      "iso24028",
      "dicom",
      "ihe"
    ],
    "excerpt": "Capability of a product to perform specified functions under specified conditions for a specified period of time without interruptions and failures."
  },
  {
    "id": "reliable-backup-and-restore",
    "label": "Reliable Backup and Restore",
    "labels": [
      "Reliable Backup and Restore"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/reliable-backup-and-restore"
  },
  {
    "id": "reliable-erh-system",
    "label": "Reliable ERH System",
    "labels": [
      "Reliable ERH System"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/reliable-erh-system"
  },
  {
    "id": "replaceability",
    "label": "Replaceability",
    "labels": [
      "Replaceability"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/replaceability",
    "standards": [
      "iso25010"
    ],
    "excerpt": "Capability of a product to replace another specified product for the same purpose in the same environment"
  },
  {
    "id": "replication-and-quorum-failure-transparency",
    "label": "Replication and Quorum Reads/Writes",
    "labels": [
      "Replication and Quorum Reads/Writes"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/replication-and-quorum-failure-transparency"
  },
  {
    "id": "reproducibility",
    "label": "Reproducibility",
    "labels": [
      "Reproducibility",
      "Repeatability"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/reproducibility",
    "standards": [
      "do178c",
      "iso29119"
    ],
    "excerpt": "Reproducibility, closely related to replicability and repeatability, is a major principle where any results should be documented by making all data and code available in such a way that the computations can be executed again with identical…"
  },
  {
    "id": "resilience",
    "label": "Resilience",
    "labels": [
      "Resilience"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/resilience",
    "standards": [
      "cra",
      "isoiec22989",
      "iso42030",
      "etsien304223",
      "nistairmf"
    ],
    "excerpt": "Resilience is the ability to \"provide and maintain an acceptable level of service in the face of faults and challenges to normal operation.\""
  },
  {
    "id": "resistance",
    "label": "Resistance",
    "labels": [
      "Resistance"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/resistance",
    "standards": [
      "iso25010",
      "owaspasvs"
    ],
    "excerpt": "Capability of a product to sustain operations while under attack from a malicious actor. A malicious attack can include a denial of service attack, a ransomware attack, or other malicious actions."
  },
  {
    "id": "resource-efficiency",
    "label": "Resource efficiency",
    "labels": [
      "Resource efficiency"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/resource-efficiency",
    "excerpt": "Resource efficiency is the maximising of the supply of money, materials, staff, and other assets that can be drawn on by a person or organization in order to function effectively, with minimum wasted (natural) resource expenses."
  },
  {
    "id": "resource-utilization",
    "label": "Resource utilization",
    "labels": [
      "Resource utilization"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/resource-utilization",
    "standards": [
      "iso25010",
      "iso14756"
    ],
    "excerpt": "Use no more than the specified amount of resources to perform its function under specified conditions."
  },
  {
    "id": "respond-to-15000-requests-per-workday",
    "label": "Respond to 15000 requests per workday",
    "labels": [
      "Respond to 15000 requests per workday"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/respond-to-15000-requests-per-workday"
  },
  {
    "id": "response-time",
    "label": "Response Time",
    "labels": [
      "Response Time"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/response-time",
    "excerpt": "The time period between a terminal operator’s completion of an inquiry and the receipt of a response. Response time includes the time taken to transmit the inquiry, process it by the computer, and transmit the response back to the terminal.…"
  },
  {
    "id": "response-time-for-image-rendering",
    "label": "Response time for image rendering",
    "labels": [
      "Response time for image rendering"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/response-time-for-image-rendering"
  },
  {
    "id": "responsive-design",
    "label": "Responsive Design",
    "labels": [
      "Responsive Design"
    ],
    "size": 20,
    "color": "#92ef80",
    "qualityType": "approach",
    "page": "/approaches/responsive-design"
  },
  {
    "id": "responsiveness",
    "label": "Responsiveness",
    "labels": [
      "Responsiveness"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/responsiveness",
    "excerpt": "Responsiveness as a concept of computer science refers to the specific ability of a system or functional unit to complete assigned tasks within a given time."
  },
  {
    "id": "restore-filter-after-log-in",
    "label": "Restore Filter after Log In",
    "labels": [
      "Restore Filter after Log In"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/restore-filter-after-log-in"
  },
  {
    "id": "mttr-12h",
    "label": "Restored to fully functional state 12h after complete failure",
    "labels": [
      "Restored to fully functional state 12h after complete failure"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/mttr-12h"
  },
  {
    "id": "restricted-memory",
    "label": "Restricted Memory",
    "labels": [
      "Restricted Memory"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/restricted-memory"
  },
  {
    "id": "retail-demand-forecast-drift-before-replenishment",
    "label": "Retail demand forecast drift detected before replenishment",
    "labels": [
      "Retail demand forecast drift detected before replenishment"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/retail-demand-forecast-drift-before-replenishment"
  },
  {
    "id": "reusability",
    "label": "Reusability",
    "labels": [
      "Reusability"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/reusability",
    "standards": [
      "iso25010"
    ],
    "excerpt": "Capability of a product to be used as assets in more than one system, or in building other assets."
  },
  {
    "id": "risk-identification",
    "label": "Risk identification",
    "labels": [
      "Risk identification"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/risk-identification",
    "standards": [
      "iso25010",
      "cra"
    ],
    "excerpt": "Capability of a product to identify a course of events or operations that can expose life, property or environment to unacceptable risk"
  },
  {
    "id": "robustness",
    "label": "Robustness",
    "labels": [
      "Robustness"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/robustness",
    "standards": [
      "iso26262",
      "misra-c",
      "isoiec22989",
      "iec62443",
      "do178c",
      "wcag22",
      "en301549",
      "iso24028",
      "etsien304223",
      "iso25059"
    ],
    "excerpt": "The ability of the product to continue to function under abnormal circumstances."
  },
  {
    "id": "rollout-new-feature",
    "label": "Rollout of a new feature",
    "labels": [
      "Rollout of a new feature"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/rollout-new-feature"
  },
  {
    "id": "safe-integration",
    "label": "Safe integration",
    "labels": [
      "Safe integration"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/safe-integration",
    "standards": [
      "iso25010"
    ],
    "excerpt": "Capability of a product to maintain safety during and after integration with one or more components."
  },
  {
    "id": "safety",
    "label": "Safety",
    "labels": [
      "Safety"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/safety",
    "standards": [
      "iso25010",
      "iso26262",
      "misra-c",
      "aiuc1",
      "iec62304",
      "iec61508",
      "isoiec22989",
      "do178c",
      "iso24028",
      "iso25019",
      "nistairmf"
    ],
    "excerpt": "Capability of a product under defined conditions to avoid a state in which human life, health, property, or the environment is endangered."
  },
  {
    "id": "safety-interlocks",
    "label": "Safety Interlocks",
    "labels": [
      "Safety Interlocks"
    ],
    "size": 20,
    "color": "#92ef80",
    "qualityType": "approach",
    "page": "/approaches/safety-interlocks"
  },
  {
    "id": "safety-requirements-traceable-to-evidence",
    "label": "Safety requirements traceable to executable evidence",
    "labels": [
      "Safety requirements traceable to executable evidence"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/safety-requirements-traceable-to-evidence"
  },
  {
    "id": "saga-pattern",
    "label": "Saga Pattern",
    "labels": [
      "Saga Pattern"
    ],
    "size": 20,
    "color": "#92ef80",
    "qualityType": "approach",
    "page": "/approaches/saga-pattern"
  },
  {
    "id": "carbon-efficiency-save",
    "label": "Save at least 20% of carbon emissions with every new version",
    "labels": [
      "Save at least 20% of carbon emissions with every new version"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/carbon-efficiency-save"
  },
  {
    "id": "scalability",
    "label": "Scalability",
    "labels": [
      "Scalability"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/scalability",
    "standards": [
      "iso25010",
      "iso42030",
      "iso12207",
      "sox",
      "ieee2857",
      "hl7",
      "dicom"
    ],
    "excerpt": "Scalability is the property of a system to handle a growing amount of work by adding resources to the system."
  },
  {
    "id": "scale-up-in-2-minutes",
    "label": "Scale up in 2 Minutes",
    "labels": [
      "Scale up in 2 Minutes"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/scale-up-in-2-minutes"
  },
  {
    "id": "search-and-graph-text-filter-available-on-q42",
    "label": "Search and graph text filter available on Q42",
    "labels": [
      "Search and graph text filter available on Q42"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/search-and-graph-text-filter-available-on-q42"
  },
  {
    "id": "secret-management",
    "label": "Secret Management",
    "labels": [
      "Secret Management"
    ],
    "size": 20,
    "color": "#92ef80",
    "qualityType": "approach",
    "page": "/approaches/secret-management"
  },
  {
    "id": "securability",
    "label": "Securability",
    "labels": [
      "Securability"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/securability",
    "standards": [
      "cra"
    ],
    "excerpt": "Ability of a system to provide different levels of secure access"
  },
  {
    "id": "security",
    "label": "Security",
    "labels": [
      "Security",
      "Information Security"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/security",
    "standards": [
      "iso25010",
      "iso27001",
      "iso26262",
      "misra-c",
      "nist80053",
      "iso5055",
      "pcidss",
      "iso42001",
      "aiuc1",
      "iec62304",
      "hl7",
      "iso15408",
      "cra",
      "isoiec22989",
      "iec62443",
      "do178c",
      "gdpr",
      "iso29100",
      "iso42030",
      "iso12207",
      "sox",
      "ieee2857",
      "iso24028",
      "etsien304223",
      "owaspasvs",
      "nistairmf",
      "dicom",
      "ihe"
    ],
    "excerpt": "Capability of a product to protect information and data so that persons or other products have the degree of data access appropriate to their types and levels of authorization, and to defend against attack patterns by malicious actors."
  },
  {
    "id": "self-contained-systems",
    "label": "Self-Contained Systems",
    "labels": [
      "Self-Contained Systems",
      "SCS"
    ],
    "size": 20,
    "color": "#92ef80",
    "qualityType": "approach",
    "page": "/approaches/self-contained-systems"
  },
  {
    "id": "self-containedness",
    "label": "Self-containedness",
    "labels": [
      "Self-containedness"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/self-containedness",
    "excerpt": "Each SCS is an autonomous web application. For the SCS's domain, all data, the logic to process that data and all code to render the web interface is contained within the SCS. An SCS can fulfill its primary use cases on its own, without hav…"
  },
  {
    "id": "self-descriptiveness",
    "label": "Self-descriptiveness",
    "labels": [
      "Self-descriptiveness"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/self-descriptiveness",
    "standards": [
      "iso25010",
      "iso42010"
    ],
    "excerpt": "Capability of a product to present appropriate information, where needed by the user, to make its capabilities and use immediately obvious to the user without excessive interactions with a product or other resources."
  },
  {
    "id": "server-fails-operation-without-downtime",
    "label": "Server fails, system continues to operate without downtime",
    "labels": [
      "Server fails, system continues to operate without downtime"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/server-fails-operation-without-downtime"
  },
  {
    "id": "circuit-breaker-failure-transparency",
    "label": "Service Circuit Breakers and Graceful Degradation",
    "labels": [
      "Service Circuit Breakers and Graceful Degradation"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/circuit-breaker-failure-transparency"
  },
  {
    "id": "service-loose-coupling-change-blast-radius",
    "label": "Service loose coupling: change blast radius",
    "labels": [
      "Service loose coupling: change blast radius"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/service-loose-coupling-change-blast-radius"
  },
  {
    "id": "shutdown-to-safe-state",
    "label": "Severe errors are detected and the system shuts down into safe state",
    "labels": [
      "Severe errors are detected and the system shuts down into safe state"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/shutdown-to-safe-state"
  },
  {
    "id": "shared-library-adoption-by-product-teams",
    "label": "Shared library adoption by product teams",
    "labels": [
      "Shared library adoption by product teams"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/shared-library-adoption-by-product-teams"
  },
  {
    "id": "shutdown-time",
    "label": "Shutdown Time",
    "labels": [
      "Shutdown Time"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/shutdown-time",
    "excerpt": "Coloquially, the duration required for a system, application, service or hardware to get from fully operational and ready state to a halt- or off-state."
  },
  {
    "id": "sidecar",
    "label": "Sidecar",
    "labels": [
      "Sidecar",
      "Ambassador"
    ],
    "size": 20,
    "color": "#92ef80",
    "qualityType": "approach",
    "page": "/approaches/sidecar"
  },
  {
    "id": "simplicity",
    "label": "Simplicity",
    "labels": [
      "Simplicity"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/simplicity",
    "excerpt": "For software, “simple” means easy to read, understand, and correctly modify."
  },
  {
    "id": "soc2",
    "label": "SOC 2 — Service Organization Control 2",
    "size": 45,
    "color": "#ffc95c",
    "qualityType": "standard",
    "page": "/standards/soc-2"
  },
  {
    "id": "sox",
    "label": "SOX - Sarbanes-Oxley Act",
    "size": 45,
    "color": "#ffc95c",
    "qualityType": "standard",
    "page": "/standards/sox"
  },
  {
    "id": "speed",
    "label": "Speed",
    "labels": [
      "Speed"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/speed",
    "excerpt": "Rate of motion or velocity."
  },
  {
    "id": "stability",
    "label": "Stability",
    "labels": [
      "Stability"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/stability",
    "excerpt": "Software stability means the resistance to the amplification of changes in software."
  },
  {
    "id": "standby-failover",
    "label": "Standby/Failover",
    "labels": [
      "Standby/Failover",
      "Redundancy",
      "Hot Spare",
      "Warm Spare",
      "Cold Spare",
      "Active Redundancy",
      "Passive Redundancy"
    ],
    "size": 20,
    "color": "#92ef80",
    "qualityType": "approach",
    "page": "/approaches/standby-failover"
  },
  {
    "id": "startup-time",
    "label": "Startup Time",
    "labels": [
      "Startup Time"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/startup-time",
    "excerpt": "Coloquially, the duration required for a system, application, or service to become fully operational and ready to use (by either human users or external systems) from the moment it is initiated."
  },
  {
    "id": "strong-authentication",
    "label": "Strong Authentication (MFA / OIDC)",
    "labels": [
      "Strong Authentication (MFA / OIDC)"
    ],
    "size": 20,
    "color": "#92ef80",
    "qualityType": "approach",
    "page": "/approaches/strong-authentication"
  },
  {
    "id": "suitability",
    "label": "Suitability",
    "labels": [
      "Suitability"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/suitability",
    "standards": [
      "iso25019"
    ],
    "excerpt": "extent to which behaviours or outcomes, or both, of a product meet (satisfy) specified quality requirements when used."
  },
  {
    "id": "sustainability",
    "label": "Sustainability",
    "labels": [
      "Sustainability",
      "Environmental Sustainability"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/sustainability",
    "standards": [
      "iso38500",
      "iso42030",
      "iso25059"
    ],
    "excerpt": "Sustainability refers to the ability of a system to meet the needs of the present without compromising the ability of future generations to meet their own needs. It emphasizes the long-term viability, resilience, and adaptability of the sys…"
  },
  {
    "id": "swappable-llm-provider",
    "label": "Swappable LLM Provider",
    "labels": [
      "Swappable LLM Provider"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/swappable-llm-provider"
  },
  {
    "id": "long-running-without-reboot",
    "label": "System can run >12h without re-booting the operating system",
    "labels": [
      "System can run >12h without re-booting the operating system"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/long-running-without-reboot"
  },
  {
    "id": "system-runs-offline",
    "label": "System runs offline",
    "labels": [
      "System runs offline"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/system-runs-offline"
  },
  {
    "id": "tamper-evident-digital-signatures",
    "label": "Tamper-Evident Digital Contract Signatures",
    "labels": [
      "Tamper-Evident Digital Contract Signatures"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/tamper-evident-digital-signatures"
  },
  {
    "id": "test-coverage",
    "label": "Test Coverage",
    "labels": [
      "Test Coverage"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/test-coverage",
    "excerpt": "The term test coverage used in the context of programming / software engineering, refers to measuring how much a software program has been exercised by tests. Coverage is a means of determining the rigour with which the question underlying…"
  },
  {
    "id": "test-coverage-for-critical-business-logic",
    "label": "Test Coverage for Critical Business Logic",
    "labels": [
      "Test Coverage for Critical Business Logic"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/test-coverage-for-critical-business-logic"
  },
  {
    "id": "test-with-path-coverage-30min",
    "label": "Test with path coverage in 30min",
    "labels": [
      "Test with path coverage in 30min"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/test-with-path-coverage-30min"
  },
  {
    "id": "testability",
    "label": "Testability",
    "labels": [
      "Testability",
      "Unit Testability"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/testability",
    "standards": [
      "iso25010",
      "iso26262",
      "misra-c",
      "iec61508",
      "iso15408",
      "do178c",
      "iso24028",
      "iso29119",
      "ihe"
    ],
    "excerpt": "Capability of a product to enable an objective and feasible test to be designed and performed to determine whether a requirement is met."
  },
  {
    "id": "themability",
    "label": "Themability",
    "labels": [
      "Themability"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/themability",
    "excerpt": "Themability allows for stylistic changes to a design system, often through design tokens or stylesheet variables. It enables a single codebase to support multiple brands or variations, where components share the same structure but can have…"
  },
  {
    "id": "threat-modeling",
    "label": "Threat Modeling",
    "labels": [
      "Threat Modeling",
      "STRIDE",
      "Attack Trees"
    ],
    "size": 20,
    "color": "#92ef80",
    "qualityType": "approach",
    "page": "/approaches/threat-modeling"
  },
  {
    "id": "throughput",
    "label": "Throughput",
    "labels": [
      "Throughput"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/throughput",
    "standards": [
      "iso14756"
    ],
    "excerpt": "Network throughput (or just throughput, when in context) refers to the rate of message delivery over a communication channel, such as Ethernet or packet radio, in a communication network. Throughput is usually measured in bits per second (b…"
  },
  {
    "id": "time-behaviour",
    "label": "Time behaviour",
    "labels": [
      "Time behaviour"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/time-behaviour",
    "standards": [
      "iso25010",
      "iso14756"
    ],
    "excerpt": "Response and processing times and throughput rates of a product or system, when performing its functions, meet requirements."
  },
  {
    "id": "time-to-market",
    "label": "Time to Market",
    "labels": [
      "Time to Market",
      "Speed To Market"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/time-to-market",
    "standards": [
      "iso42030"
    ],
    "excerpt": "Time to market (TTM) is the length of time it takes from a product being conceived until it is available for sale."
  },
  {
    "id": "timeliness",
    "label": "Timeliness",
    "labels": [
      "Timeliness",
      "Currentness"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/timeliness",
    "standards": [
      "iso25024"
    ],
    "excerpt": "The degree to which data is up-to-date and available when needed for decision-making or processing."
  },
  {
    "id": "timeout",
    "label": "Timeout",
    "labels": [
      "Timeout",
      "Deadline"
    ],
    "size": 20,
    "color": "#92ef80",
    "qualityType": "approach",
    "page": "/approaches/timeout"
  },
  {
    "id": "tolerant-reader",
    "label": "Tolerant Reader",
    "labels": [
      "Tolerant Reader",
      "Postel's Law",
      "Robustness Principle"
    ],
    "size": 20,
    "color": "#92ef80",
    "qualityType": "approach",
    "page": "/approaches/tolerant-reader"
  },
  {
    "id": "traceability",
    "label": "Traceability",
    "labels": [
      "Traceability"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/traceability",
    "standards": [
      "iso26262",
      "iec62304",
      "hl7",
      "iso15408",
      "cra",
      "isoiec22989",
      "iso25024",
      "do178c",
      "iso42010",
      "gdpr",
      "iso42030",
      "iso12207",
      "sox",
      "etsien304223",
      "iso8000",
      "ieee7000",
      "dicom",
      "ihe"
    ],
    "excerpt": "Traceability is the ability to recover all of the artifacts that led to an element having a problem. That includes all the code and dependencies that are included in that element. It also includes the test cases that were run on that elemen…"
  },
  {
    "id": "transaction-processing-faultlessness",
    "label": "Transaction Processing Operates Without Fault Under Normal Load",
    "labels": [
      "Transaction Processing Operates Without Fault Under Normal Load"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/transaction-processing-faultlessness"
  },
  {
    "id": "transactional-outbox",
    "label": "Transactional Outbox",
    "labels": [
      "Transactional Outbox"
    ],
    "size": 20,
    "color": "#92ef80",
    "qualityType": "approach",
    "page": "/approaches/transactional-outbox"
  },
  {
    "id": "transactionality",
    "label": "Transactionality",
    "labels": [
      "Transactionality"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/transactionality",
    "excerpt": "A transaction is a sequence of operations performed as a single, logical unit of work. For a transaction to be considered complete, all operations within it must succeed. If any single operation fails, the entire transaction fails, and the…"
  },
  {
    "id": "transparency",
    "label": "Transparency",
    "labels": [
      "Transparency"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/transparency",
    "standards": [
      "iso38500",
      "iso42001",
      "cra",
      "isoiec22989",
      "isoiec12792",
      "iso42010",
      "gdpr",
      "iso42030",
      "sox",
      "ieee2857",
      "iso24028",
      "etsien304223",
      "nistairmf",
      "ieee7000",
      "iso25059"
    ],
    "excerpt": "the quality of being easy to see through. a situation in which business and financial activities are done in an open way without secrets, so that people can trust that they are fair and honest…"
  },
  {
    "id": "unavailability-max-2-minutes",
    "label": "Unavailable for max 2 minutes",
    "labels": [
      "Unavailable for max 2 minutes"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/unavailability-max-2-minutes"
  },
  {
    "id": "understandability",
    "label": "Understandability",
    "labels": [
      "Understandability",
      "Comprehensibility"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/understandability",
    "standards": [
      "misra-c",
      "iso26514",
      "iso25024",
      "iso42010",
      "iso42030",
      "wcag22",
      "en301549"
    ],
    "excerpt": "Understandability is the concept that a system should be presented so that (somebody) can easily comprehend it. The more understandable a system is, the easier it will be for engineers to change it in a predictable and safe manner."
  },
  {
    "id": "understandable-acceptance-tests",
    "label": "Understandable acceptance test cases",
    "labels": [
      "Understandable acceptance test cases"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/understandable-acceptance-tests"
  },
  {
    "id": "understandable-generated-code",
    "label": "Understandable generated code",
    "labels": [
      "Understandable generated code"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/understandable-generated-code"
  },
  {
    "id": "up-to-date-api",
    "label": "Up to date API",
    "labels": [
      "Up to date API"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/up-to-date-api"
  },
  {
    "id": "updateability",
    "label": "Updateability",
    "labels": [
      "Updateability"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/updateability",
    "standards": [
      "cra",
      "iso25010",
      "iec62304",
      "iec61508"
    ],
    "excerpt": "Updateability refers to the capability of a software system to efficiently receive, install, and integrate updates, patches, security fixes, and minor enhancements while maintaining system integrity and minimizing service disruption."
  },
  {
    "id": "upgradeability",
    "label": "Upgradeability",
    "labels": [
      "Upgradeability"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/upgradeability",
    "standards": [
      "cra"
    ],
    "excerpt": "Upgrading is the process of replacing a product with a newer version of the same product. In computing and consumer electronics an upgrade is generally a replacement of hardware, software or firmware with a newer or better version, in order…"
  },
  {
    "id": "usability",
    "label": "Usability",
    "labels": [
      "Usability"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/usability",
    "standards": [
      "iec62304",
      "isoiec22989",
      "iso26514",
      "iso12207",
      "wcag22",
      "en301549",
      "iso25019"
    ],
    "excerpt": "Capability of a product to be used by specified users to exchange information between a user and an interactive system via the user interface to complete the intended task."
  },
  {
    "id": "usable-despite-color-blindness",
    "label": "Usable Despite Color Blindness",
    "labels": [
      "Usable Despite Color Blindness"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/usable-despite-color-blindness"
  },
  {
    "id": "usable-on-factory-floor",
    "label": "Usable on Factory Floor",
    "labels": [
      "Usable on Factory Floor"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/usable-on-factory-floor"
  },
  {
    "id": "usable-with-gloves",
    "label": "Usable With Gloves",
    "labels": [
      "Usable With Gloves"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/usable-with-gloves"
  },
  {
    "id": "user-assistance",
    "label": "User assistance",
    "labels": [
      "User assistance"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/user-assistance",
    "standards": [
      "iso25010"
    ],
    "excerpt": "Capability of a product to be used by people with the widest range of characteristics and capabilities to achieve specified goals in a specified context of use."
  },
  {
    "id": "user-engagement",
    "label": "User engagement",
    "labels": [
      "User engagement"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/user-engagement",
    "standards": [
      "iso25010"
    ],
    "excerpt": "Capability of a product to present functions and information in an inviting and motivating manner, supporting continued interaction. This refers to properties of the product that increase the pleasure and satisfaction of the user, such as h…"
  },
  {
    "id": "user-error-protection",
    "label": "User error protection",
    "labels": [
      "User error protection"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/user-error-protection",
    "standards": [
      "iso25010",
      "wcag22",
      "en301549"
    ],
    "excerpt": "Capability of a product to protect users against making operation errors"
  },
  {
    "id": "user-experience",
    "label": "User experience",
    "labels": [
      "User experience"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/user-experience",
    "standards": [
      "iso25019"
    ],
    "excerpt": "User experience includes all the aspects of the interaction between the end-user with the company, its services, and its products."
  },
  {
    "id": "user-interface-aesthetics",
    "label": "User interface aesthetics",
    "labels": [
      "User interface aesthetics"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/user-interface-aesthetics",
    "excerpt": "Capability of a user interface to enable pleasing and satisfying interaction for the user"
  },
  {
    "id": "user-interface-works-with-current-browsers",
    "label": "User Interface can be used in Current Browsers",
    "labels": [
      "User Interface can be used in Current Browsers"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/user-interface-works-with-current-browsers"
  },
  {
    "id": "user-tries-primary-function",
    "label": "User tries to achieve primary function",
    "labels": [
      "User tries to achieve primary function"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/user-tries-primary-function"
  },
  {
    "id": "accurate-vehicle-position-gps",
    "label": "Vehicle's position validity influences accuracy",
    "labels": [
      "Vehicle's position validity influences accuracy"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/accurate-vehicle-position-gps"
  },
  {
    "id": "verifiability",
    "label": "Verifiability",
    "labels": [
      "Verifiability"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/verifiability",
    "standards": [
      "do178c",
      "iso42010",
      "iso29119",
      "ihe"
    ],
    "excerpt": "System Verification is a set of actions used to check the correctness of any element, such as a system element, a system, a document, a service, a task, a requirement, etc. These types of actions are planned and carried out throughout the l…"
  },
  {
    "id": "versatility",
    "label": "Versatility",
    "labels": [
      "Versatility"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/versatility",
    "excerpt": "able to change easily or to be used for different purposes"
  },
  {
    "id": "vulnerability",
    "label": "Vulnerability",
    "labels": [
      "Vulnerability"
    ],
    "size": 25,
    "color": "#00b8f5",
    "qualityType": "quality",
    "page": "/qualities/vulnerability",
    "standards": [
      "owaspasvs"
    ],
    "excerpt": "A software vulnerability is a defect in software that could allow an attacker to gain control of a system. These defects can be because of the way the software is designed, or because of a flaw in the way that it’s coded."
  },
  {
    "id": "watchdog-supervision",
    "label": "Watchdog Supervision",
    "labels": [
      "Watchdog Supervision",
      "Monitor"
    ],
    "size": 20,
    "color": "#92ef80",
    "qualityType": "approach",
    "page": "/approaches/watchdog-supervision"
  },
  {
    "id": "wcag22",
    "label": "WCAG 2.2 - Web Content Accessibility Guidelines",
    "size": 45,
    "color": "#ffc95c",
    "qualityType": "standard",
    "page": "/standards/wcag-2-2"
  },
  {
    "id": "withstand-ddos-attack",
    "label": "Withstand DDoS Attack",
    "labels": [
      "Withstand DDoS Attack"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/withstand-ddos-attack"
  },
  {
    "id": "zero-knowledge-data-storage",
    "label": "Zero-knowledge data storage",
    "labels": [
      "Zero-knowledge data storage"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/zero-knowledge-data-storage"
  },
  {
    "id": "zone-failure-no-service-interruption",
    "label": "Zone failure: no service interruption",
    "labels": [
      "Zone failure: no service interruption"
    ],
    "size": 15,
    "color": "#ffb3b3",
    "qualityType": "requirement",
    "page": "/requirements/zone-failure-no-service-interruption"
  }
]